
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("hysf6", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");


var $aWwYt = parcelRequire("aWwYt");


var $jvYFk = parcelRequire("jvYFk");


var $42omo = parcelRequire("42omo");


var $8tSmd = parcelRequire("8tSmd");


var $1s5hv = parcelRequire("1s5hv");

const $c3510951803c5233$export$b127d30889efe7fe = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tSmd))), {
        label: ""
    }));
};






var $eyWa4 = parcelRequire("eyWa4");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $ep3mz = parcelRequire("ep3mz");


var $67Foi = parcelRequire("67Foi");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");





var $1GzhS = parcelRequire("1GzhS");

var $ecnYn = parcelRequire("ecnYn");





var $4PPzL = parcelRequire("4PPzL");








var $6767u = parcelRequire("6767u");

/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");





var $j1Ss3 = parcelRequire("j1Ss3");





var $cD1qu = parcelRequire("cD1qu");


var $htsj6 = parcelRequire("htsj6");


var $9wGTI = parcelRequire("9wGTI");

const $f8025aa33ba82d7f$export$90053f8722608fdd = (ownedBy)=>!!ownedBy && 'accountId' in ownedBy;
const $f8025aa33ba82d7f$export$988945b3d699075c = (name, maxChar)=>{
    if (name.length <= maxChar) return name;
    return `${name.slice(0, maxChar)}...`;
};


const $4ed8f2cda16eb725$export$275ac55729c181ca = (data)=>{
    const contentNode = data?.content?.nodes?.[0];
    const createdBy = contentNode?.history?.createdBy;
    const generatedBy = contentNode?.contentProperties?.latest?.generatedBy;
    // If the page was generated by ONBOARDING, show "Confluence" as the creator
    if (generatedBy === 'ONBOARDING') return {
        accountId: null,
        displayName: 'Confluence',
        profilePicturePath: 'confluence-icon'
    };
    return {
        accountId: (0, $f8025aa33ba82d7f$export$90053f8722608fdd)(createdBy) ? createdBy?.accountId : '',
        displayName: createdBy?.displayName ?? '',
        profilePicturePath: createdBy?.profilePicture?.path
    };
};


/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 















const $498256fa12521bbe$export$cb2464d13a6f2491 = (data)=>{
    const ownedBy = data?.content?.nodes?.[0]?.history?.ownedBy;
    return {
        accountId: (0, $f8025aa33ba82d7f$export$90053f8722608fdd)(ownedBy) ? ownedBy?.accountId : '',
        displayName: ownedBy?.displayName ?? '',
        profilePicturePath: ownedBy?.profilePicture?.path
    };
};


const $9771e03e1c2beb91$var$useContentOwnerDetailsPanelContentOwnerQuery = (0, $eSUdr.default)`query useContentOwnerDetailsPanelContentOwnerQuery($contentId:ID!$status:String!){content(id:$contentId status:[$status]){nodes{id history{ownedBy{type displayName ...on KnownUser{accountId}profilePicture{path}}}}}}`;
const $9771e03e1c2beb91$export$952bbc51fdbffa6e = ({ skip: skip = false } = {})=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { contentStatus: contentStatus, loading: isContentStatusLoading, error: contentStatusError, refetch: refetchContentStatus } = (0, $htsj6.useContentStatus)({
        skip: skip
    });
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $j1Ss3.useQuery)($9771e03e1c2beb91$var$useContentOwnerDetailsPanelContentOwnerQuery, {
        variables: {
            contentId: contentId ?? '',
            status: contentStatus ?? ''
        },
        skip: skip || isContentStatusLoading || !!contentStatusError || !contentStatus || !contentId
    });
    const normalizedData = (0, $42omo.useMemo)(()=>(0, $498256fa12521bbe$export$cb2464d13a6f2491)(data), [
        data
    ]);
    return {
        data: normalizedData,
        loading: loading,
        error: contentStatusError || error,
        refetch: !!contentStatusError ? refetchContentStatus : refetch
    };
};


const $977ba6942676c3d8$var$useContentCreatorDetailsPanelContentCreatedByQuery = (0, $eSUdr.default)`query useContentCreatorDetailsPanelContentCreatedByQuery($contentId:ID!$status:String!$includeGeneratedBy:Boolean=false){content(id:$contentId status:[$status]){nodes{id history{createdBy{type displayName ...on KnownUser{accountId}profilePicture{path}}}contentProperties@include(if:$includeGeneratedBy){latest{generatedBy}}}}}`;
const $977ba6942676c3d8$export$958c3f0906de8016 = ()=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { contentStatus: contentStatus, loading: isContentStatusLoading, error: contentStatusError, refetch: refetchContentStatus } = (0, $htsj6.useContentStatus)();
    const isContentStatusDraft = contentStatus === (0, $cD1qu.ContentStatus).DRAFT;
    const { data: createdByData, loading: isCreatedByLoading, error: createdByError, refetch: refetchCreatedBy } = (0, $j1Ss3.useQuery)($977ba6942676c3d8$var$useContentCreatorDetailsPanelContentCreatedByQuery, {
        variables: {
            contentId: contentId ?? '',
            status: contentStatus ?? '',
            // Feature flag to control whether to fetch generatedBy field
            includeGeneratedBy: (0, $9wGTI.fg)('confluence_frontend_confluence_creator_onboarding')
        },
        skip: isContentStatusLoading || !!contentStatusError || !contentStatus || !contentId || isContentStatusDraft
    });
    const normalizedCreatedByData = (0, $42omo.useMemo)(()=>(0, $4ed8f2cda16eb725$export$275ac55729c181ca)(createdByData), [
        createdByData
    ]);
    const { data: contentOwnerData, loading: isContentOwnerLoading, error: contentOwnerError, refetch: refetchContentOwner } = (0, $9771e03e1c2beb91$export$952bbc51fdbffa6e)({
        skip: !isContentStatusDraft
    });
    const refetchUserData = isContentStatusDraft ? refetchContentOwner : refetchCreatedBy;
    return {
        data: isContentStatusDraft ? contentOwnerData : normalizedCreatedByData,
        loading: isContentStatusLoading || isCreatedByLoading || isContentOwnerLoading,
        error: contentStatusError || createdByError || contentOwnerError,
        refetch: contentStatusError ? refetchContentStatus : refetchUserData
    };
};






var $8C5kA = parcelRequire("8C5kA");


var $3wBuN = parcelRequire("3wBuN");

var $esRft = parcelRequire("esRft");


var $u9agA = parcelRequire("u9agA");


var $3gadb = parcelRequire("3gadb");


var $2Nwuj = parcelRequire("2Nwuj");


var $kpYGL = parcelRequire("kpYGL");


var $fwDOR = parcelRequire("fwDOR");


var $lAFHW = parcelRequire("lAFHW");


var $a6t12 = parcelRequire("a6t12");


var $1NBp8 = parcelRequire("1NBp8");






var $dcJ7R = parcelRequire("dcJ7R");



const $7489de58f9d21175$var$detailRowStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.100',
    height: 'size.200'
});
const $7489de58f9d21175$export$3ea9d70abca6f185 = ({ icon: icon, itemName: itemName, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        spread: "space-between",
        alignBlock: "center",
        xcss: $7489de58f9d21175$var$detailRowStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.100",
        alignBlock: "center"
    }, icon, itemName), children);
};











var $a3fRD = parcelRequire("a3fRD");




var $2W0qg = parcelRequire("2W0qg");







var $b3j2Y = parcelRequire("b3j2Y");

const $c5268d744aecc17b$var$retryStyle = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral.subtle',
    color: 'color.text.information'
});
const $c5268d744aecc17b$var$i18n = (0, $cgtv4.defineMessages)({
    retry: {
        id: "details-panel.error-retry",
        defaultMessage: "Retry"
    },
    errorInfo: {
        id: "details-panel.error-info",
        defaultMessage: "Failed to load"
    },
    errorIconLabel: {
        id: "details-panel.error-icon-label",
        defaultMessage: "error icon"
    }
});
const $c5268d744aecc17b$export$51c55327f05e286f = ({ error: error, refetch: refetch })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        position: "bottom",
        content: formatMessage($c5268d744aecc17b$var$i18n.errorInfo)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: formatMessage($c5268d744aecc17b$var$i18n.errorIconLabel)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
        xcss: $c5268d744aecc17b$var$retryStyle,
        onClick: ()=>refetch()
    }, formatMessage($c5268d744aecc17b$var$i18n.retry))));
};


const $5787f3e4addf8e3a$var$MAX_DISPLAY_NAME_LENGTH = 25;
const $5787f3e4addf8e3a$var$PEOPLE_DIRECTORY_URL = (0, $1NBp8.PEOPLE_DIRECTORY).toUrl();
const $5787f3e4addf8e3a$var$noop = ()=>{};
const $5787f3e4addf8e3a$export$2360cd0b07b95057 = ({ loadingTestId: loadingTestId, icon: icon, analyticsRole: analyticsRole, i18n: { personLabel: personLabel, accessibleAvatarLabel: accessibleAvatarLabel }, data: { accountId: accountId, displayName: displayName, profilePicturePath: profilePicturePath }, error: error, refetch: refetch, loading: loading })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const renderPersonRow = ()=>{
        if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
            name: "person-row-details-panel-hold"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "80px",
            height: "24px",
            borderRadius: 3,
            testId: loadingTestId
        }));
        if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c5268d744aecc17b$export$51c55327f05e286f), {
            error: error,
            refetch: refetch
        });
        const profileURL = accountId ? `${$5787f3e4addf8e3a$var$PEOPLE_DIRECTORY_URL}/${accountId}` : '';
        const truncatedName = (0, $f8025aa33ba82d7f$export$988945b3d699075c)(displayName, $5787f3e4addf8e3a$var$MAX_DISPLAY_NAME_LENGTH);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            alignBlock: "center",
            alignInline: "center",
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: displayName
        }, profileURL ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
            appearance: "subtle",
            href: profileURL,
            analyticsContext: {
                source: 'contentWrapper',
                attributes: {
                    role: analyticsRole,
                    name: 'profileName'
                }
            }
        }, truncatedName) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, truncatedName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6t12.ProfileCardWrapper), {
            userId: accountId
        }, profilePicturePath === 'confluence-icon' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
            size: "small",
            href: profileURL,
            name: formatMessage(accessibleAvatarLabel, {
                displayName: displayName
            }),
            onClick: /* an analytics event is only fired if onClick is provided,
        	but providing onClick will change behavior if href is not provided */ profileURL ? $5787f3e4addf8e3a$var$noop : undefined,
            analyticsContext: {
                source: 'contentWrapper',
                attributes: {
                    role: analyticsRole,
                    name: 'profileImage'
                }
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3wBuN.AvatarContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.ConfluenceIcon), {
            size: "small",
            appearance: "brand"
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
            size: "small",
            href: profileURL,
            src: profilePicturePath ?? undefined,
            name: formatMessage(accessibleAvatarLabel, {
                displayName: displayName
            }),
            onClick: /* an analytics event is only fired if onClick is provided,
        	but providing onClick will change behavior if href is not provided */ profileURL ? $5787f3e4addf8e3a$var$noop : undefined,
            analyticsContext: {
                source: 'contentWrapper',
                attributes: {
                    role: analyticsRole,
                    name: 'profileImage'
                }
            }
        })));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7489de58f9d21175$export$3ea9d70abca6f185), {
        itemName: formatMessage(personLabel),
        icon: icon
    }, renderPersonRow());
};


const $db34986343c8c2ca$var$i18n = (0, $cgtv4.defineMessages)({
    creator: {
        id: "details-panel.properties-section.creator-row",
        defaultMessage: "Creator"
    },
    accessibleAvatarLabel: {
        id: "details-panel.properties-section.creator-row.accessible-avatar-label",
        defaultMessage: "{displayName}\u2019s profile picture"
    }
});
const $db34986343c8c2ca$export$8167c69147b0585a = ()=>{
    const { data: data, error: error, refetch: refetch, loading: loading } = (0, $977ba6942676c3d8$export$958c3f0906de8016)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5787f3e4addf8e3a$export$2360cd0b07b95057), {
        loadingTestId: "creator-row-loading",
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6767u))), {
            label: ""
        }),
        analyticsRole: "creator",
        i18n: {
            accessibleAvatarLabel: $db34986343c8c2ca$var$i18n.accessibleAvatarLabel,
            personLabel: $db34986343c8c2ca$var$i18n.creator
        },
        data: data,
        error: error,
        refetch: refetch,
        loading: loading
    });
};











var $2Pg7f = parcelRequire("2Pg7f");


var $lebfc = parcelRequire("lebfc");







/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 











const $3c80799d096a63bb$export$d6b021e12eff4360 = (data)=>({
        nodes: data?.contentContributors?.nodes ?? []
    });




var $4qzKl = parcelRequire("4qzKl");


var $jlIaF = parcelRequire("jlIaF");


const $986c400a3d0a417e$export$a068fd1ce1bc7e = ({ nodes: nodes, ownerAccountId: ownerAccountId })=>nodes.filter((contributor)=>{
        if (!contributor) return false; // Exclude null contributors
        if (!(0, $f8025aa33ba82d7f$export$90053f8722608fdd)(contributor)) return true; // Include contributors without an accountId, as they can't be the owner
        return contributor.accountId !== ownerAccountId; // Exclude contributors whose accountId matches the owner's accountId
    }).map((contributor)=>{
        const accountId = (0, $f8025aa33ba82d7f$export$90053f8722608fdd)(contributor) ? contributor.accountId : null;
        return {
            name: contributor.displayName || '',
            href: (0, $4qzKl.getAtlassianPeopleProfileUrl)(accountId, '', (0, $jlIaF.CONTEXT_PATH)),
            src: contributor.profilePicture?.path || ''
        };
    });


const $351541e5ad9e9537$var$useContentContributorsDetailsPanelContentContributorsQuery = (0, $eSUdr.default)`query useContentContributorsDetailsPanelContentContributorsQuery($contentId:ID!$contributorLimit:Int!){contentContributors(id:$contentId limit:$contributorLimit){nodes{type displayName ...on KnownUser{accountId}profilePicture{path}}}}`;
const $351541e5ad9e9537$export$71c38423f4606a00 = 2147483647;
const $351541e5ad9e9537$export$ff0c1b4124f50967 = ()=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { data: contentOwnerData, refetch: refetchContentOwner, error: contentOwnerError, loading: isContentOwnerLoading } = (0, $9771e03e1c2beb91$export$952bbc51fdbffa6e)();
    const { accountId: ownerAccountId } = contentOwnerData;
    const { data: contentContributorsData, loading: isContentContributorsLoading, error: contentContributorsError, refetch: refetchContentContributors } = (0, $j1Ss3.useQuery)($351541e5ad9e9537$var$useContentContributorsDetailsPanelContentContributorsQuery, {
        variables: {
            contentId: contentId ?? '',
            contributorLimit: $351541e5ad9e9537$export$71c38423f4606a00
        },
        skip: !contentId
    });
    const formattedNodes = (0, $42omo.useMemo)(()=>{
        const { nodes: nodes } = (0, $3c80799d096a63bb$export$d6b021e12eff4360)(contentContributorsData);
        return (0, $986c400a3d0a417e$export$a068fd1ce1bc7e)({
            nodes: nodes,
            ownerAccountId: ownerAccountId
        });
    }, [
        contentContributorsData,
        ownerAccountId
    ]);
    return {
        data: {
            nodes: formattedNodes,
            count: formattedNodes.length
        },
        loading: isContentOwnerLoading || isContentContributorsLoading,
        error: contentOwnerError || contentContributorsError,
        refetch: contentOwnerError ? refetchContentOwner : refetchContentContributors
    };
};




const $3ab98a3e7bf32b9d$var$i18n = (0, $cgtv4.defineMessages)({
    contributors: {
        id: "details-panel.contributor-row.contributors",
        defaultMessage: "Contributors"
    }
});
const $3ab98a3e7bf32b9d$var$noop = ()=>{};
const $3ab98a3e7bf32b9d$export$9904cc2fa820959 = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { data: data, error: error, refetch: refetch, loading: loading } = (0, $351541e5ad9e9537$export$ff0c1b4124f50967)();
    const { nodes: nodes } = data;
    const safeNodes = nodes ?? [];
    if (safeNodes.length === 0 && !error) return null;
    const nodesWithAnalyticsContext = safeNodes.map((node)=>({
            ...node,
            /* an analytics event is only fired if onClick is provided,
    	 but providing onClick will change behavior if href is not provided */ onClick: node.href ? $3ab98a3e7bf32b9d$var$noop : undefined,
            analyticsContext: {
                source: 'contentWrapper',
                attributes: {
                    role: 'contributor',
                    name: 'profileImage'
                }
            }
        }));
    const renderContributorsSectionContent = ()=>{
        if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
            name: "contributors-row-details-panel-hold"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "80px",
            height: "24px",
            borderRadius: 3,
            testId: "contributors-row-loading"
        }));
        if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c5268d744aecc17b$export$51c55327f05e286f), {
            error: error,
            refetch: refetch
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Pg7f.default), {
            size: "small",
            maxCount: 3,
            appearance: "stack",
            data: nodesWithAnalyticsContext
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7489de58f9d21175$export$3ea9d70abca6f185), {
        itemName: formatMessage($3ab98a3e7bf32b9d$var$i18n.contributors),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lebfc))), {
            label: ""
        })
    }, renderContributorsSectionContent());
};









var $1Zr9M = parcelRequire("1Zr9M");

/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 















const $c6ba6157f312bb22$export$8fdb104004fb8098 = (data)=>{
    const lastUpdatedBy = data?.content?.nodes?.[0]?.history?.lastUpdated?.by;
    return {
        accountId: (0, $f8025aa33ba82d7f$export$90053f8722608fdd)(lastUpdatedBy) ? lastUpdatedBy?.accountId : '',
        displayName: lastUpdatedBy?.displayName ?? '',
        profilePicturePath: lastUpdatedBy?.profilePicture?.path
    };
};


const $d8f8c1c8c95f9c6a$var$useContentLastUpdatedDetailsPanelContentLastUpdatedQuery = (0, $eSUdr.default)`query useContentLastUpdatedDetailsPanelContentLastUpdatedQuery($contentId:ID!$status:String!){content(id:$contentId status:[$status]){nodes{id history{lastUpdated{by{type displayName ...on KnownUser{accountId}profilePicture{path}}}}}}}`;
const $d8f8c1c8c95f9c6a$export$151985ea30c617ee = ({ skip: skip = false } = {})=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { contentStatus: contentStatus, loading: isContentStatusLoading, error: contentStatusError, refetch: refetchContentStatus } = (0, $htsj6.useContentStatus)({
        skip: skip
    });
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $j1Ss3.useQuery)($d8f8c1c8c95f9c6a$var$useContentLastUpdatedDetailsPanelContentLastUpdatedQuery, {
        variables: {
            contentId: contentId ?? '',
            status: contentStatus ?? ''
        },
        skip: skip || isContentStatusLoading || !!contentStatusError || !contentStatus || !contentId
    });
    const normalizedData = (0, $42omo.useMemo)(()=>(0, $c6ba6157f312bb22$export$8fdb104004fb8098)(data), [
        data
    ]);
    return {
        data: normalizedData,
        loading: loading,
        error: contentStatusError || error,
        refetch: !!contentStatusError ? refetchContentStatus : refetch
    };
};



const $2d63f9c687d4cb76$var$i18n = (0, $cgtv4.defineMessages)({
    lastUpdatedBy: {
        id: "details-panel.properties-section.last-updated-row",
        defaultMessage: "Last updated by"
    },
    accessibleAvatarLabel: {
        id: "details-panel.properties-section.last-updated-row.accessible-avatar-label",
        defaultMessage: "{displayName}\u2019s profile picture"
    }
});
const $2d63f9c687d4cb76$export$f546c79bd733f286 = ()=>{
    const { data: data, error: error, refetch: refetch, loading: loading } = (0, $d8f8c1c8c95f9c6a$export$151985ea30c617ee)();
    if (!loading && !error && !data.accountId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5787f3e4addf8e3a$export$2360cd0b07b95057), {
        loadingTestId: "last-updated-row-loading",
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))), {
            label: ""
        }),
        analyticsRole: "lastUpdater",
        i18n: {
            accessibleAvatarLabel: $2d63f9c687d4cb76$var$i18n.accessibleAvatarLabel,
            personLabel: $2d63f9c687d4cb76$var$i18n.lastUpdatedBy
        },
        data: data,
        error: error,
        refetch: refetch,
        loading: loading
    });
};






var $gdv5Z = parcelRequire("gdv5Z");





















var $6f0Oj = parcelRequire("6f0Oj");



var $5dK2X = parcelRequire("5dK2X");











var $jFm04 = parcelRequire("jFm04");


var $eq5ww = parcelRequire("eq5ww");


var $bkahn = parcelRequire("bkahn");


var $873qR = parcelRequire("873qR");


var $hJe2K = parcelRequire("hJe2K");

const $e14ff18a942ab015$var$i18n = (0, $cgtv4.defineMessages)({
    owner: {
        id: "content-ownership.content-owner-item.owner",
        defaultMessage: "Owner"
    },
    creator: {
        id: "content-ownership.content-owner-item.creator",
        defaultMessage: "Creator"
    },
    ownerOrCreatorWithContributors: {
        id: "content-ownership.content-owner-item.owner-or-creator-with-contributors",
        defaultMessage: "{isBlogpost, select, true {Creator} other {Owner}}{noOtherContributors, select, true {, no contributors} other {}}"
    },
    changeOwner: {
        id: "content-ownership.content-owner-item.change-owner",
        defaultMessage: "Change owner"
    },
    accessibleAvatarLabel: {
        id: "content-ownership.content-owner-item.accessible-avatar-label",
        defaultMessage: "{displayName}\u2019s profile picture"
    }
});
function $e14ff18a942ab015$var$noop() {
// intentionally empty
}
const $e14ff18a942ab015$export$6753f78cf3cd0bfa = ({ ownerAccountId: ownerAccountId, ownerName: ownerName, ownerAvatarUrl: ownerAvatarUrl, contentType: contentType, contentStatus: contentStatus, noOtherContributors: noOtherContributors, isCurrentUserSpaceAdmin: isCurrentUserSpaceAdmin, analyticsSource: analyticsSource })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const ownerProfileUrl = ownerAccountId ? `${(0, $1NBp8.PEOPLE_DIRECTORY).toUrl()}/${ownerAccountId}` : '';
    const avatarLabel = formatMessage($e14ff18a942ab015$var$i18n.accessibleAvatarLabel, {
        displayName: ownerName
    });
    const userTitle = (0, $873qR.useUserTitle)({
        contentType: contentType,
        noOtherContributors: noOtherContributors
    });
    const isChangeOwnerAvailable = (0, $bkahn.useIsChangeOwnerAvailable)({
        ownerAccountId: ownerAccountId,
        isCurrentUserSpaceAdmin: isCurrentUserSpaceAdmin,
        contentType: contentType,
        contentStatus: contentStatus
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        spread: "space-between",
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6t12.ProfileCardWrapper), {
        userId: ownerAccountId,
        position: "left",
        trigger: "hover",
        fullName: ownerName ?? undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
        size: "large",
        borderColor: "transparent",
        href: ownerProfileUrl,
        src: ownerAvatarUrl ?? undefined,
        name: avatarLabel,
        onClick: /* an analytics event is only fired if onClick is provided,
                             but providing onClick will change behavior if href is not provided */ ownerProfileUrl ? $e14ff18a942ab015$var$noop : undefined,
        analyticsContext: {
            source: analyticsSource,
            attributes: {
                role: 'owner',
                name: 'profileImage'
            }
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        appearance: "subtle",
        href: ownerProfileUrl,
        analyticsContext: {
            source: analyticsSource,
            attributes: {
                role: 'owner',
                name: 'profileName'
            }
        }
    }, ownerName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        size: "small",
        color: "color.text.subtlest"
    }, userTitle)))), isChangeOwnerAvailable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jFm04.ContentOwnershipContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jFm04.ContentOwnershipContextConsumer), null, ({ openModal: openModal })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eq5ww.ChangeContentOwnerButton), {
            onClick: openModal,
            analyticsContext: (0, $hJe2K.getChangeOwnerButtonAnalyticsContext)(analyticsSource, 'false')
        });
    })));
};





/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 











const $0644a504f6f1ed16$export$2cf64df9c654b040 = (data)=>({
        isCurrentUserSpaceAdmin: data?.space?.currentUser.isAdmin ?? false
    });


const $6a049aa03dd83dd3$var$useSpaceAdminDetailsPanelSpaceAdminQuery = (0, $eSUdr.default)`query useSpaceAdminDetailsPanelSpaceAdminQuery($spaceKey:String!){space(key:$spaceKey){id currentUser{isAdmin}}}`;
const $6a049aa03dd83dd3$export$fbe9dbcc8265d013 = ()=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $j1Ss3.useQuery)($6a049aa03dd83dd3$var$useSpaceAdminDetailsPanelSpaceAdminQuery, {
        skip: !spaceKey,
        variables: {
            spaceKey: spaceKey ?? ''
        }
    });
    const normalizedData = (0, $42omo.useMemo)(()=>(0, $0644a504f6f1ed16$export$2cf64df9c654b040)(data), [
        data
    ]);
    return {
        data: normalizedData,
        loading: loading,
        error: error,
        refetch: refetch
    };
};





const $f7dbfed1c486b1fb$export$cfad9ff853a9b88 = ()=>{
    const { type: contentType, contentStatus: contentStatus, loading: contentStatusLoading, error: contentStatusError, refetch: contentStatusRefetch } = (0, $htsj6.useContentStatus)();
    const { data: contentOwnerData, loading: contentOwnerLoading, error: contentOwnerError, refetch: contentOwnerRefetch } = (0, $9771e03e1c2beb91$export$952bbc51fdbffa6e)();
    const { data: spaceAdminData, loading: spaceAdminLoading, error: spaceAdminError, refetch: spaceAdminRefetch } = (0, $6a049aa03dd83dd3$export$fbe9dbcc8265d013)();
    const { data: contentContributors, loading: contentContributorsLoading, error: contentContributorsError, refetch: contentContributorsRefetch } = (0, $351541e5ad9e9537$export$ff0c1b4124f50967)();
    const noOtherContributors = contentContributorsLoading ? undefined : contentContributors?.count === 0;
    const error = contentStatusError || contentOwnerError || spaceAdminError || contentContributorsError;
    const refetch = (0, $42omo.useCallback)(()=>{
        if (contentStatusError) contentStatusRefetch();
        if (contentOwnerError) contentOwnerRefetch();
        if (spaceAdminError) spaceAdminRefetch();
        if (contentContributorsError) contentContributorsRefetch();
    }, [
        contentStatusError,
        contentStatusRefetch,
        contentOwnerError,
        contentOwnerRefetch,
        spaceAdminError,
        spaceAdminRefetch,
        contentContributorsError,
        contentContributorsRefetch
    ]);
    const renderOwnerSectionContent = ()=>{
        if (contentStatusLoading || contentOwnerLoading || spaceAdminLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
            name: "owner-section-details-panel-hold"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.150",
            testId: "owner-section-loading"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "40px",
            height: "40px",
            borderRadius: 200
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "154px",
            height: "32px",
            borderRadius: 4
        })));
        if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c5268d744aecc17b$export$51c55327f05e286f), {
            error: error,
            refetch: refetch
        });
        const { accountId: accountId, profilePicturePath: profilePicturePath, displayName: displayName } = contentOwnerData;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e14ff18a942ab015$export$6753f78cf3cd0bfa), {
            ownerAccountId: accountId,
            ownerName: displayName,
            ownerAvatarUrl: profilePicturePath,
            contentType: contentType,
            contentStatus: contentStatus,
            noOtherContributors: noOtherContributors,
            isCurrentUserSpaceAdmin: spaceAdminData.isCurrentUserSpaceAdmin,
            analyticsSource: "contentWrapper"
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        paddingBlockStart: "space.025",
        testId: "owner-section"
    }, renderOwnerSectionContent());
};


const $a458f954e7688173$var$peopleSectionStyles = (0, $ecnYn.xcss)({
    paddingLeft: 'space.300',
    paddingRight: 'space.300'
});
const $a458f954e7688173$var$secondaryPeopleStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.200'
});
const $a458f954e7688173$export$dd2d4d0b8ec52ff3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).DISCO
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        xcss: $a458f954e7688173$var$peopleSectionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f7dbfed1c486b1fb$export$cfad9ff853a9b88), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        xcss: $a458f954e7688173$var$secondaryPeopleStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3ab98a3e7bf32b9d$export$9904cc2fa820959), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $db34986343c8c2ca$export$8167c69147b0585a), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2d63f9c687d4cb76$export$f546c79bd733f286), null))));








var $gtD4K = parcelRequire("gtD4K");



















var $5qLRP = parcelRequire("5qLRP");










var $iXCQx = parcelRequire("iXCQx");


var $kevJM = parcelRequire("kevJM");







/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 














const $328740414a8a528a$export$3c7c438d43cf7462 = (data)=>({
        date: data?.content?.nodes?.[0]?.metadata.createdDate
    });


const $30db04ac345f7e3d$var$useContentCreatedDateDetailsPanelContentCreatedDateQuery = (0, $eSUdr.default)`query useContentCreatedDateDetailsPanelContentCreatedDateQuery($contentId:ID!$status:String!){content(id:$contentId status:[$status]){nodes{id metadata{createdDate}}}}`;
const $30db04ac345f7e3d$export$12ec296467271c17 = ()=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { contentStatus: contentStatus, loading: isContentStatusLoading, error: contentStatusError, refetch: refetchContentStatus } = (0, $htsj6.useContentStatus)();
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $j1Ss3.useQuery)($30db04ac345f7e3d$var$useContentCreatedDateDetailsPanelContentCreatedDateQuery, {
        variables: {
            contentId: contentId ?? '',
            status: contentStatus ?? ''
        },
        skip: isContentStatusLoading || !!contentStatusError || !contentStatus || !contentId
    });
    const normalizedData = (0, $42omo.useMemo)(()=>(0, $328740414a8a528a$export$3c7c438d43cf7462)(data), [
        data
    ]);
    return {
        data: normalizedData,
        loading: loading,
        error: contentStatusError || error,
        refetch: !!contentStatusError ? refetchContentStatus : refetch
    };
};




const $53ff80f51b06f91e$var$i18n = (0, $cgtv4.defineMessages)({
    created: {
        id: "details-panel.properties-section.created-row",
        defaultMessage: "Created"
    }
});
const $53ff80f51b06f91e$export$4e325fd01f4587a7 = ()=>{
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $8C5kA.default)();
    const { data: data, error: error, refetch: refetch, loading: loading } = (0, $30db04ac345f7e3d$export$12ec296467271c17)();
    const { date: date } = data;
    const renderCreatedItem = ()=>{
        if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
            name: "created-row-stats-sections-details-panel-hold"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "80px",
            height: "24px",
            borderRadius: 3,
            testId: "created-row-loading"
        }));
        if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c5268d744aecc17b$export$51c55327f05e286f), {
            error: error,
            refetch: refetch
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, formatDate(new Date(date ?? ''), {
            year: 'numeric',
            month: 'long',
            day: '2-digit'
        }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7489de58f9d21175$export$3ea9d70abca6f185), {
        itemName: formatMessage($53ff80f51b06f91e$var$i18n.created),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kevJM))), {
            label: ""
        })
    }, renderCreatedItem());
};











var $cUQMr = parcelRequire("cUQMr");


var $04VgG = parcelRequire("04VgG");





var $aSsfA = parcelRequire("aSsfA");





var $kDhla = parcelRequire("kDhla");


const $85a07c25d450f933$var$i18n = (0, $cgtv4.defineMessages)({
    length: {
        id: "details-panel.properties-section.length-row",
        defaultMessage: "Length"
    }
});
const $85a07c25d450f933$export$8f2787e5ba19fef6 = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { fullPageEditorPresetAPI: fullPageEditorPresetAPI } = (0, $kDhla.useFullPageEditorApiState)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7489de58f9d21175$export$3ea9d70abca6f185), {
        itemName: formatMessage($85a07c25d450f933$var$i18n.length),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cUQMr))), {
            label: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $04VgG.ReadTime), {
        editorApi: fullPageEditorPresetAPI,
        contentId: contentId ?? '',
        isAbbreviatedReadTime: false,
        isInEditor: pageMode !== (0, $cD1qu.PageMode).VIEW,
        isDetailsPanel: true,
        showWordCount: true
    }));
};











var $8cjip = parcelRequire("8cjip");








var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");







/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 


















var $9wEpK = parcelRequire("9wEpK");

const $8e5e49c94bc995d9$export$894159de174be35c = [
    400,
    401,
    403
];
const $8e5e49c94bc995d9$export$8389c83400af11e2 = (error, expectedCodes)=>{
    if ((0, $9wEpK.isApolloError)(error)) return error.graphQLErrors.some((e)=>expectedCodes.includes(e?.extensions?.statusCode));
    else return expectedCodes.includes(error?.extensions?.statusCode);
};


/**
 * @generated SignedSource<<39d2453dc7c13b5654cfb1c99310e98e>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $f900541107f8b546$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});


const $1eee0af454f19ff4$export$468b695a94ab1e9b = (data)=>{
    const contentAnalyticsViewers = data?.contentAnalyticsViewers;
    const user = data?.user;
    return {
        count: contentAnalyticsViewers?.count,
        isInternalUser: user?.confluence?.permissionType === (0, $f900541107f8b546$export$8995abb8169b2cb8).INTERNAL,
        isSSRError: contentAnalyticsViewers === null
    };
};


const $e1afb2c18c2938ee$var$useContentViewsDetailsPanelContentViewsQuery = (0, $eSUdr.default)`query useContentViewsDetailsPanelContentViewsQuery($contentId:ID!$isDraft:Boolean!){contentAnalyticsViewers(contentId:$contentId)@skip(if:$isDraft){count}user:confluence_atlassianUser(current:true){id confluence{permissionType}}}`;
const $e1afb2c18c2938ee$export$1a13176cfacebb13 = ()=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { contentStatus: contentStatus, loading: isContentStatusLoading, error: contentStatusError, refetch: refetchContentStatus } = (0, $htsj6.useContentStatus)();
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $j1Ss3.useQuery)($e1afb2c18c2938ee$var$useContentViewsDetailsPanelContentViewsQuery, {
        variables: {
            contentId: contentId ?? '',
            isDraft: contentStatus === (0, $cD1qu.ContentStatus).DRAFT
        },
        skip: isContentStatusLoading || !!contentStatusError || !contentStatus || !contentId
    });
    const isPermissionError = error && (0, $8e5e49c94bc995d9$export$8389c83400af11e2)(error, (0, $8e5e49c94bc995d9$export$894159de174be35c));
    const normalizedData = (0, $42omo.useMemo)(()=>(0, $1eee0af454f19ff4$export$468b695a94ab1e9b)(data), [
        data
    ]);
    const { count: count, isInternalUser: isInternalUser, isSSRError: isSSRError } = normalizedData;
    const contentViewsError = contentStatusError || error;
    // It should not be possible for the user to see "0 views", since the user is technically viewing the page
    // at that moment. However, due to the eventually consistent behavior of the analytics data, it is possible
    // that 0 comes back from the analytics service.
    const adjustedCount = count === 0 ? 1 : count;
    return {
        data: {
            ...normalizedData,
            count: adjustedCount
        },
        loading: loading,
        error: contentViewsError,
        refetch: !!contentStatusError ? refetchContentStatus : refetch,
        shouldHideViewsAnalytics: Boolean(isPermissionError || !isInternalUser || isSSRError || contentViewsError || loading)
    };
};







var $6R5uz = parcelRequire("6R5uz");


var $8tdj3 = parcelRequire("8tdj3");







var $bUlM5 = parcelRequire("bUlM5");







const $a99dcf3b2d873545$var$pressableStyles = (0, $ecnYn.xcss)({
    ':hover': {
        textDecoration: 'underline'
    }
});
const $a99dcf3b2d873545$var$linkBoxStyles = (0, $ecnYn.xcss)({
    ':focus-within': {
        outline: `2px solid ${"var(--ds-border-focused, #4688EC)"}`
    }
});
const $a99dcf3b2d873545$export$902dde2c01bb0707 = ({ href: href, children: children, onClick: onClick, onClickDisabled: onClickDisabled = false, analyticsContext: analyticsContext })=>{
    const linkContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        color: "color.text.subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        alignItems: "center",
        gap: "space.150"
    }, children, href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
        label: "",
        color: "var(--ds-icon-subtlest, #6B6E76)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
        label: "",
        color: "var(--ds-icon-subtlest, #6B6E76)"
    })));
    return href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $a99dcf3b2d873545$var$linkBoxStyles,
        paddingInline: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        appearance: "subtle",
        href: href,
        analyticsContext: analyticsContext,
        onClick: onClick
    }, linkContent)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
        onClick: onClick,
        analyticsContext: analyticsContext,
        padding: "space.100",
        backgroundColor: "color.background.neutral.subtle",
        xcss: $a99dcf3b2d873545$var$pressableStyles,
        isDisabled: onClickDisabled
    }, linkContent);
};



const $be8d014ae40f1f99$var$i18n = (0, $cgtv4.defineMessages)({
    viewsSection: {
        id: "details-panel.activity-section.views-row",
        defaultMessage: "Views"
    }
});
const $be8d014ae40f1f99$var$ViewsRow = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { data: data, error: error, refetch: refetch, loading: loading, shouldHideViewsAnalytics: shouldHideViewsAnalytics } = (0, $e1afb2c18c2938ee$export$1a13176cfacebb13)();
    const { count: count } = data;
    const renderViewsItem = ()=>{
        if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
            name: "views-row-details-panel-hold"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "48px",
            height: "24px",
            borderRadius: 3,
            testId: "views-row-loading"
        }));
        if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c5268d744aecc17b$export$51c55327f05e286f), {
            error: error,
            refetch: refetch
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a99dcf3b2d873545$export$902dde2c01bb0707), {
            href: (0, $1NBp8.PAGE_ANALYTICS).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            }),
            analyticsContext: {
                source: 'contentWrapper',
                attributes: {
                    name: 'views'
                }
            }
        }, count);
    };
    return !shouldHideViewsAnalytics ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7489de58f9d21175$export$3ea9d70abca6f185), {
        itemName: formatMessage($be8d014ae40f1f99$var$i18n.viewsSection),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8cjip))), {
            label: ""
        })
    }, renderViewsItem()) : null;
};
const $be8d014ae40f1f99$export$45a1c12e916e9584 = ()=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const isNotFreeEdition = edition !== (0, $d9tcB.ConfluenceEdition).FREE;
    return isNotFreeEdition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($be8d014ae40f1f99$var$ViewsRow, null) : null;
};


const $d646f513af901061$var$i18n = (0, $cgtv4.defineMessages)({
    statsSectionTitle: {
        id: "details-panel.stats-section.title",
        defaultMessage: "Stats"
    }
});
const $d646f513af901061$var$statsSectionStyles = (0, $ecnYn.xcss)({
    paddingLeft: 'space.300',
    paddingRight: 'space.300',
    marginTop: 'space.300'
});
const $d646f513af901061$export$49e22b3583223277 = ()=>{
    const { isElementVisible: isElementVisible } = (0, $5qLRP.useElementVisibility)();
    const { contentStatus: contentStatus } = (0, $htsj6.useContentStatus)();
    const isDraft = contentStatus === (0, $cD1qu.ContentStatus).DRAFT;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        xcss: $d646f513af901061$var$statsSectionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...$d646f513af901061$var$i18n.statsSectionTitle,
        tagName: "h4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).DISCO
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), null, isElementVisible((0, $5qLRP.ELEMENTS).ROWS.VIEWS) && !isDraft && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $be8d014ae40f1f99$export$45a1c12e916e9584), null), isElementVisible((0, $5qLRP.ELEMENTS).ROWS.LENGTH) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $85a07c25d450f933$export$8f2787e5ba19fef6), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $53ff80f51b06f91e$export$4e325fd01f4587a7), null))));
};






var $T1bCI = parcelRequire("T1bCI");












var $bJX6u = parcelRequire("bJX6u");








var $1ggpj = parcelRequire("1ggpj");














var $4wEOc = parcelRequire("4wEOc");

















var $bFMG7 = parcelRequire("bFMG7");










const $99d8376f24017f55$export$e948ce957637ade5 = ()=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { contentStatus: contentStatus, loading: isContentStatusLoading, error: contentStatusError, refetch: refetchContentStatus } = (0, $htsj6.useContentStatus)();
    const contentClassificationMetadata = (0, $bFMG7.useContentClassification)({
        contentId: contentId,
        spaceKeyOverride: spaceKey,
        contentStatusContext: contentStatus === (0, $cD1qu.ContentStatus).DRAFT || pageMode === (0, $cD1qu.PageMode).EDIT ? 'draft-only' : 'current-and-draft',
        shouldSkipQueries: !contentStatus,
        shouldReadFromQueries: true
    });
    const isContentClassificationMetadataLoading = contentClassificationMetadata.contentLevelLoading;
    return {
        data: contentClassificationMetadata,
        loading: isContentStatusLoading || isContentClassificationMetadataLoading,
        error: contentStatusError,
        refetch: refetchContentStatus
    };
};


const $818e9fd1178a0334$export$fa044869294621ea = ()=>{
    const [contentType] = (0, $ep3mz.useContentType)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { data: data } = (0, $99d8376f24017f55$export$e948ce957637ade5)();
    const { isEnabled: isDataClassificationEnabled } = (0, $4wEOc.useIsDataClassificationEnabledForOrg)({
        skip: (0, $9wGTI.fg)('disable_classification_enabled_query')
    });
    //Read from different sources based on flag value
    const classificationFeatureEnabled = (0, $9wGTI.fg)('disable_classification_enabled_query') ? data?.featureEnabled : isDataClassificationEnabled;
    const isDataClassificationEmptyOnViewPage = pageMode === (0, $cD1qu.PageMode).VIEW && !data.classification;
    const isDataClassificationEnabledForContentType = contentType === (0, $1ggpj.ContentType).DATABASE || contentType === (0, $1ggpj.ContentType).WHITEBOARD;
    return classificationFeatureEnabled && (!isDataClassificationEmptyOnViewPage || isDataClassificationEnabledForContentType);
};











var $f2ref = parcelRequire("f2ref");











var $inPa6 = parcelRequire("inPa6");


var $jkVM2 = parcelRequire("jkVM2");


var $4S6vT = parcelRequire("4S6vT");


var $lfBMY = parcelRequire("lfBMY");


var $2wo33 = parcelRequire("2wo33");


var $efvKr = parcelRequire("efvKr");













/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 




















const $dab8395378de95b8$export$2a267772604a148a = (data)=>{
    const singleContentState = data?.singleContent?.contentState;
    return {
        color: singleContentState?.color ?? '',
        restrictionLevel: singleContentState?.restrictionLevel,
        name: singleContentState?.name ?? ''
    };
};


const $dee56617ba39171d$var$useContentStateDetailsPanelSingleContentStateQuery = (0, $eSUdr.default)`query useContentStateDetailsPanelSingleContentStateQuery($contentId:ID!$isDraft:Boolean!$status:String!){singleContent(id:$contentId status:[$status]){contentState(isDraft:$isDraft){id name color restrictionLevel}}}`;
const $dee56617ba39171d$export$b49d63386d42e7ce = ({ isContentStateAvailable: isContentStateAvailable, ...contentState })=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { contentStatus: contentStatus, loading: isContentStatusLoading, error: contentStatusError, refetch: refetchContentStatus } = (0, $htsj6.useContentStatus)({
        skip: isContentStateAvailable
    });
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $j1Ss3.useQuery)($dee56617ba39171d$var$useContentStateDetailsPanelSingleContentStateQuery, {
        variables: {
            contentId: contentId ?? '',
            status: contentStatus ?? '',
            isDraft: contentStatus === (0, $cD1qu.ContentStatus).DRAFT || pageMode === (0, $cD1qu.PageMode).EDIT
        },
        skip: isContentStateAvailable || isContentStatusLoading || !!contentStatusError || !contentStatus || !contentId
    });
    const normalizedData = (0, $42omo.useMemo)(()=>(0, $dab8395378de95b8$export$2a267772604a148a)(data), [
        data
    ]);
    return {
        data: isContentStateAvailable ? contentState : normalizedData,
        loading: loading,
        error: contentStatusError || error,
        refetch: !!contentStatusError ? refetchContentStatus : refetch
    };
};






var $hYoU4 = parcelRequire("hYoU4");

const $2b51e0f1dd6c16f4$export$e5d3711429b4ff8 = ()=>{
    const [isDisconnected, setIsDisconnected] = (0, $42omo.useState)(false);
    const [{ collabEditProvider: collabEditProvider }] = (0, $hYoU4.useNativeCollabState)();
    const handleDisconnected = ()=>{
        setIsDisconnected(true);
    };
    const handleConnected = ()=>{
        setIsDisconnected(false);
    };
    (0, $42omo.useEffect)(()=>{
        if (!collabEditProvider) return;
        collabEditProvider.on('connected', handleConnected);
        collabEditProvider.on('disconnected', handleDisconnected);
        return ()=>{
            collabEditProvider.off('connected', handleConnected);
            collabEditProvider.off('disconnected', handleDisconnected);
        };
    });
    return isDisconnected;
};




const $1645549588f034e2$var$i18n = (0, $cgtv4.defineMessages)({
    status: {
        id: "details-panel.properties-section.status-row",
        defaultMessage: "Status"
    }
});
const $1645549588f034e2$var$readOnlyStatusStyles = (0, $ecnYn.xcss)({
    paddingLeft: 'space.050',
    paddingRight: 'space.025'
});
const $1645549588f034e2$var$readOnlyTextStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.025',
    marginRight: 'space.025'
});
const $1645549588f034e2$var$StatusRowComponent = ({ color: color, restrictionLevel: restrictionLevel, name: name, contentId: contentId, contentType: contentType, userOffline: userOffline, isEditAllowed: isEditAllowed })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onClick = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: `button`,
                actionSubjectId: 'SidePanelStatus',
                source: 'contentWrapper'
            }
        }).fire();
    };
    return isEditAllowed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jkVM2.EditorContentState), {
        contentId: contentId,
        contentType: contentType,
        userOffline: userOffline,
        renderPlusButtonEmptyState: true,
        isDetailsPanel: true,
        onClick: onClick
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        xcss: [
            $1645549588f034e2$var$readOnlyStatusStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4S6vT.ContentStateColor), {
        color: color,
        // (Make sure that the colorAppearance is set to the same value as used in the editable
        //  version found in next/packages/content-state/src/EditorContentState/ContentStateButton.tsx)
        appearance: "rendererContentState",
        restrictionLevel: restrictionLevel
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $1645549588f034e2$var$readOnlyTextStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, name)));
};
const $1645549588f034e2$export$8247e1fed55911f6 = (contentState)=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { data: data, error: error, refetch: refetch } = (0, $dee56617ba39171d$export$b49d63386d42e7ce)(contentState);
    const { color: color, restrictionLevel: restrictionLevel, name: name } = data;
    const isContentStateAvailable = !!color || !!restrictionLevel || !!name;
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const isDisconnected = (0, $2b51e0f1dd6c16f4$export$e5d3711429b4ff8)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const { contentStatus: contentStatus } = (0, $htsj6.useContentStatus)();
    const [{ isViewMode: isLiveViewMode }] = (0, $efvKr.useLivePageMode)();
    const isContentStateEditable = pageMode === (0, $cD1qu.PageMode).EDIT || pageMode === (0, $cD1qu.PageMode).LIVE && !isLiveViewMode;
    const [canUpdateContent] = (0, $2wo33.useCanPerformContentOperation)({
        contentId: contentId ?? '',
        contentType: contentType,
        operation: (0, $lfBMY.OperationTypes).UPDATE,
        status: contentStatus === (0, $cD1qu.ContentStatus).DRAFT ? (0, $cD1qu.DRAFT_STATUS) : (0, $cD1qu.CURRENT_STATUS)
    });
    const hasEditPermission = canUpdateContent ?? false;
    const isEditAllowed = isContentStateEditable && hasEditPermission;
    // If we don't have a content state and the user is unable to add one (either from the content
    // mode they're in or because they don't have permissions), we should hide the entire row.  But
    // if there is an error, we should show the row with an error message.
    if (!isContentStateAvailable && !isEditAllowed && !error) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7489de58f9d21175$export$3ea9d70abca6f185), {
        itemName: formatMessage($1645549588f034e2$var$i18n.status),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f2ref))), {
            label: ""
        })
    }, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c5268d744aecc17b$export$51c55327f05e286f), {
        error: error,
        refetch: refetch
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1645549588f034e2$var$StatusRowComponent, {
        name: name,
        color: color,
        restrictionLevel: restrictionLevel,
        contentId: contentId,
        contentType: contentType,
        userOffline: isDisconnected,
        isEditAllowed: isEditAllowed
    }));
};











var $4GKfl = parcelRequire("4GKfl");








var $iiPY2 = parcelRequire("iiPY2");


var $in5LX = parcelRequire("in5LX");


var $4UY5S = parcelRequire("4UY5S");


























var $40pD8 = parcelRequire("40pD8");


























var $g5gZt = parcelRequire("g5gZt");


var $1qfLF = parcelRequire("1qfLF");








var $Q2uE4 = parcelRequire("Q2uE4");


var $hyiip = parcelRequire("hyiip");




const $1e6ecfc6de672e3a$var$i18n = (0, $cgtv4.defineMessages)({
    addClassificationLabel: {
        id: "details-panel.activity-section.classification-row.add-classification-label",
        defaultMessage: "Add classification"
    }
});
const $1e6ecfc6de672e3a$export$f0f12fa5eded4386 = ({ contentClassificationMetadata: contentClassificationMetadata, hasEditPermission: hasEditPermission })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { setIsClassificationModalOpen: setIsClassificationModalOpen } = (0, $40pD8.useClassificationModalDispatchContext)();
    const preloadClassificationEditorQueries = (0, $hyiip.usePreloadClassificationEditorQueries)({
        spaceKey: spaceKey
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onClick = ()=>{
        setIsClassificationModalOpen(true);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: `button`,
                actionSubjectId: 'SidePanelClassification',
                source: 'contentWrapper'
            }
        }).fire();
    };
    return hasEditPermission ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))),
        label: formatMessage($1e6ecfc6de672e3a$var$i18n.addClassificationLabel),
        onClick: onClick,
        onMouseEnter: preloadClassificationEditorQueries
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $Q2uE4.ClassificationEditModal), {
        contentId: contentId ?? '',
        spaceKey: spaceKey ?? '',
        contentClassificationMetadata: contentClassificationMetadata
    })) : null;
};


const $1ff51c643c4d2c97$export$97f94bd873b44a4d = ({ contentClassificationMetadata: contentClassificationMetadata, onRestoreFocus: onRestoreFocus, buttonTestId: buttonTestId })=>{
    const isDisconnected = (0, $2b51e0f1dd6c16f4$export$e5d3711429b4ff8)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { contentStatus: contentStatus } = (0, $htsj6.useContentStatus)();
    const [canUpdateContent] = (0, $2wo33.useCanPerformContentOperation)({
        contentId: contentId ?? '',
        contentType: contentType,
        operation: (0, $lfBMY.OperationTypes).UPDATE,
        status: contentStatus === (0, $cD1qu.ContentStatus).DRAFT ? (0, $cD1qu.DRAFT_STATUS) : (0, $cD1qu.CURRENT_STATUS)
    });
    const hasEditPermission = canUpdateContent ?? false;
    return contentClassificationMetadata.classification ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iiPY2.ContentTypeClassification), {
        spaceKey: spaceKey ?? '',
        contentId: contentId ?? '',
        userOffline: isDisconnected,
        readOnly: !hasEditPermission,
        contentType: contentType ?? '',
        contentClassificationMetadata: contentClassificationMetadata,
        popupPlacementOverride: "bottom-end",
        onRestoreFocus: onRestoreFocus,
        buttonTestId: buttonTestId,
        spacing: "expanded"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $40pD8.ClassificationModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1e6ecfc6de672e3a$export$f0f12fa5eded4386), {
        contentClassificationMetadata: contentClassificationMetadata,
        hasEditPermission: hasEditPermission
    }));
};


const $ad489d36268c3761$var$i18n = (0, $cgtv4.defineMessages)({
    classificationSection: {
        id: "details-panel.activity-section.classification-row",
        defaultMessage: "Classification"
    }
});
const $ad489d36268c3761$export$f32d9630e80ab5db = (el)=>{
    if (el) el.focus();
    else {
        const btn = document.querySelector('[data-testid="content-type-classification"]');
        if (btn) btn.focus();
    }
};
const $ad489d36268c3761$export$b3b8c7ca0930ec22 = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { data: data, error: error, loading: loading, refetch: refetch } = (0, $99d8376f24017f55$export$e948ce957637ade5)();
    const shouldRenderContentClassificationTag = contentType === (0, $1ggpj.ContentType).PAGE && (pageMode === (0, $cD1qu.PageMode).VIEW || data.flagStatus === (0, $in5LX.FlagStatus).LOADING);
    const renderClassificationItem = ()=>{
        if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
            name: "classification-row-details-panel-hold"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "80px",
            height: "24px",
            borderRadius: 3,
            testId: "classification-row-loading"
        }));
        if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c5268d744aecc17b$export$51c55327f05e286f), {
            error: error,
            refetch: refetch
        });
        return shouldRenderContentClassificationTag ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, (0, $9wGTI.fg)('confluence_classification_row_content') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iiPY2.ContentTypeClassification), {
            contentId: contentId ?? '',
            contentType: contentType ?? '',
            contentClassificationMetadata: data,
            spaceKey: spaceKey ?? '',
            onRestoreFocus: $ad489d36268c3761$export$f32d9630e80ab5db,
            buttonTestId: "content-type-classification",
            spacing: "expanded",
            readOnly: true
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4UY5S.ContentClassificationTag), {
            contentId: contentId ?? '',
            contentType: contentType ?? '',
            contentClassificationMetadata: data
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1ff51c643c4d2c97$export$97f94bd873b44a4d), {
            contentClassificationMetadata: data
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7489de58f9d21175$export$3ea9d70abca6f185), {
        itemName: formatMessage($ad489d36268c3761$var$i18n.classificationSection),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4GKfl))), {
            label: ""
        })
    }, renderClassificationItem());
};


/* LabelsSection.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");













var $av0Vd = parcelRequire("av0Vd");








var $8aF6s = parcelRequire("8aF6s");


var $4vaoM = parcelRequire("4vaoM");


var $3l7KO = parcelRequire("3l7KO");



/* Labels.tsx generated by @compiled/babel-plugin v0.36.1 */ 











var $3WVxj = parcelRequire("3WVxj");

var $ho4zm = parcelRequire("ho4zm");










const $2f2b8fc01346dbda$var$labelsStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.250'
});
const $2f2b8fc01346dbda$var$labelLinkStyles = null;
const $2f2b8fc01346dbda$var$Label = ({ label: label, hasEditPermissions: hasEditPermissions, refetch: refetch, handleDeleteLabelClick: handleDeleteLabelClick })=>{
    const [contentId = ''] = (0, $ep3mz.usePageContentId)();
    const [spaceKey = ''] = (0, $ep3mz.usePageSpaceKey)();
    const handleRemove = async ()=>{
        await handleDeleteLabelClick({
            variables: {
                contentId: contentId,
                label: label
            }
        });
        await refetch();
    };
    let labelUrl;
    if ((0, $9wGTI.fg)('confluence_frontend_labels_in_footer')) // should link to advanced search with confluence filter and labels filter. This works for both Unified Search and Advanced Search
    try {
        labelUrl = (0, $1NBp8.ADVANCED_SEARCH).toUrl({}, {
            query: {
                product: 'confluence',
                labels: label
            }
        });
    } catch (e) {
        // just in case, fallback to this so that we don't blow up the labels section in details panel
        labelUrl = '#';
    }
    else // should link to old labels route
    try {
        labelUrl = (0, $1NBp8.LABELLED_CONTENT).toUrl({
            spaceKey: spaceKey,
            labelName: encodeURIComponent(label)
        });
    } catch (e) {
        // There are many cases with special characters in labels; provide a graceful fallback in case
        // a URL for a label cannot be generated.
        labelUrl = '#';
    }
    return hasEditPermissions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3WVxj.default), {
        key: label,
        text: label,
        onAfterRemoveAction: handleRemove,
        href: labelUrl,
        linkComponent: ({ href: href, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
                href: href,
                className: (0, $gMc0m.default)([
                    "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1reo15vq _18m915vq _syaz1kw7 _1bto1l2s _o5721q9c _1nrm1r31 _1a3b1r31 _9oik1r31 _1ydc1r31 _c2waglyw _4fprglyw _1bnxglyw _1x28glyw _1iohnqa1 _5goinqa1 _jf4cnqa1 _1726nqa1 _9h8h1kw7 _f8pj1kw7 _30l31kw7 _10531kw7"
                ])
            }, children)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ho4zm.default), {
        testId: "readonly-label",
        key: label,
        text: label,
        href: labelUrl,
        linkComponent: ({ href: href, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
                href: href,
                className: (0, $gMc0m.default)([
                    "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1reo15vq _18m915vq _syaz1kw7 _1bto1l2s _o5721q9c _1nrm1r31 _1a3b1r31 _9oik1r31 _1ydc1r31 _c2waglyw _4fprglyw _1bnxglyw _1x28glyw _1iohnqa1 _5goinqa1 _jf4cnqa1 _1726nqa1 _9h8h1kw7 _f8pj1kw7 _30l31kw7 _10531kw7"
                ])
            }, children)
    });
};
const $2f2b8fc01346dbda$export$c9ed62821215deda = ({ labels: labels, refetch: refetch, hasEditPermissions: hasEditPermissions, handleDeleteLabelClick: handleDeleteLabelClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        xcss: $2f2b8fc01346dbda$var$labelsStyles,
        direction: "row",
        alignItems: "center",
        wrap: "wrap"
    }, labels.map((labelNode)=>labelNode?.label ? // eslint-disable-next-line @atlassian/a11y/label-has-associated-control -- See https://go/a11y-label-has-associated-control for more details
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2f2b8fc01346dbda$var$Label, {
            refetch: refetch,
            key: labelNode.label,
            label: labelNode.label,
            hasEditPermissions: hasEditPermissions,
            handleDeleteLabelClick: handleDeleteLabelClick
        }) : null));


const $a85fb67b97f12834$var$i18n = (0, $cgtv4.defineMessages)({
    labelsSectionTitle: {
        id: "details-panel.labels-section.title",
        defaultMessage: "Labels"
    },
    addButtonLabel: {
        id: "details-panel.labels-section.add-button-label",
        defaultMessage: "Add label"
    }
});
const $a85fb67b97f12834$export$875bcf10b1b6719c = ({ highlight: highlight })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [contentId = ''] = (0, $ep3mz.usePageContentId)();
    const [spaceKey = ''] = (0, $ep3mz.usePageSpaceKey)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { data: data, error: error, refetch: refetch, handleDeleteLabelClick: handleDeleteLabelClick, loading: loading } = (0, $3l7KO.useContentLabels)();
    const { labels: labels, hasEditPermissions: hasEditPermissions } = data;
    const scrollToRef = (el)=>{
        if (el && highlight) el.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    };
    const renderLabelsSectionContent = ()=>{
        if (error) return /*#__PURE__*/ $42omo.createElement((0, $c5268d744aecc17b$export$51c55327f05e286f), {
            error: error,
            refetch: refetch
        });
        return hasEditPermissions ? /*#__PURE__*/ $42omo.createElement((0, $fwDOR.default), {
            name: "labels-section-details-panel-hold",
            hold: loading
        }, /*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
            appearance: "subtle",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))),
            label: formatMessage($a85fb67b97f12834$var$i18n.addButtonLabel),
            onClick: ()=>showModal((0, $4vaoM.EditLabelDialogLoader), {
                    contentId: contentId,
                    spaceKey: spaceKey,
                    source: 'detailsPanel'
                }),
            isDisabled: !contentId || !spaceKey || loading,
            testId: "add-label-button"
        })) : null;
    };
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-testId": "labels-section",
        ref: scrollToRef,
        className: (0, $gMc0m.default)([
            highlight && $a85fb67b97f12834$var$styles.highlight
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $7489de58f9d21175$export$3ea9d70abca6f185), {
        itemName: formatMessage($a85fb67b97f12834$var$i18n.labelsSectionTitle),
        icon: /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($av0Vd))), {
            label: ""
        })
    }, renderLabelsSectionContent()), labels.length > 0 && /*#__PURE__*/ $42omo.createElement((0, $2f2b8fc01346dbda$export$c9ed62821215deda), {
        labels: labels,
        refetch: refetch,
        hasEditPermissions: hasEditPermissions,
        handleDeleteLabelClick: handleDeleteLabelClick
    }));
};
const $a85fb67b97f12834$var$fadeOutHighlightKeyframes = null;
const $a85fb67b97f12834$var$styles = {
    highlight: "_zulp1b66 _y44v1wck _195g10v4 _18zr1ejb _1e0c1txw _2lx21bp4 _bfhkibhp _t6vd1dm9 _5wrafeiv _1p3lnqa1"
};











var $6ZUmE = parcelRequire("6ZUmE");


var $jmjWc = parcelRequire("jmjWc");


const $657b32c3d4149a70$export$4f8d688880428f81 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Hu3kQ",
    name: "RedactionsDialogLoader",
    loader: async ()=>(await (parcelRequire("dqRJo"))).RedactionsDialog
});








/**
 * @graphql cc
 */ 









var $aMcHK = parcelRequire("aMcHK");


var $7Sm4c = parcelRequire("7Sm4c");





var $byF4U = parcelRequire("byF4U");

const $5cac77383b408187$export$5eb1a235a3599ccb = ()=>{
    const [contentType] = (0, $ep3mz.useContentType)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    // Only users with "Edit" permission should be able to see the redaction metadata
    const [canUpdateContent] = (0, $2wo33.useCanPerformContentOperation)({
        contentId: contentId ?? '',
        contentType: contentType,
        operation: (0, $lfBMY.OperationTypes).UPDATE
    });
    const { data: data, error: error, refetch: refetch } = (0, $j1Ss3.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $byF4U.DetailsPanelRedactionsRowQuery), {
        skip: !contentId || !canUpdateContent,
        variables: {
            contentId: contentId ?? ''
        },
        errorPolicy: 'all'
    });
    if ((0, $aMcHK.isStatusCodeError)(error, '404')) (0, $7Sm4c.markErrorAsHandled)(error);
    // As we will render nothing for the item, if loading, unentitled, or no redactions,
    // zero is fine as a default
    const redactionMetadataCount = data?.singleContent?.redactionMetadataCount ?? 0;
    return {
        redactionMetadataCount: redactionMetadataCount,
        error: !(0, $aMcHK.isStatusCodeError)(error, '404') ? error : null,
        refetch: refetch
    };
};





const $9c39d074e22d6463$var$i18n = (0, $cgtv4.defineMessages)({
    redactionsSection: {
        id: "details-panel.properties-section.redaction-row",
        defaultMessage: "Redactions"
    }
});
const $9c39d074e22d6463$export$e1c60e781522ee95 = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [contentId = ''] = (0, $ep3mz.usePageContentId)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { redactionMetadataCount: redactionMetadataCount, error: error, refetch: refetch } = (0, $5cac77383b408187$export$5eb1a235a3599ccb)();
    const handleRedactionsItemClick = (0, $42omo.useCallback)(()=>{
        showModal((0, $657b32c3d4149a70$export$4f8d688880428f81), {
            contentId: contentId
        });
    }, [
        showModal,
        contentId
    ]);
    if (!redactionMetadataCount && !error) return null;
    const renderRedactionsItem = ()=>{
        if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c5268d744aecc17b$export$51c55327f05e286f), {
            error: error,
            refetch: refetch
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a99dcf3b2d873545$export$902dde2c01bb0707), {
            onClick: handleRedactionsItemClick,
            onClickDisabled: !contentId,
            analyticsContext: {
                source: 'contentWrapper',
                attributes: {
                    name: 'redactions',
                    count: redactionMetadataCount
                }
            }
        }, `${redactionMetadataCount}`);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7489de58f9d21175$export$3ea9d70abca6f185), {
        itemName: formatMessage($9c39d074e22d6463$var$i18n.redactionsSection),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6ZUmE))), {
            label: ""
        })
    }, renderRedactionsItem());
};


const $8b1e24b6aff8f803$var$i18n = (0, $cgtv4.defineMessages)({
    propertiesSectionTitle: {
        id: "details-panel.info-section.title",
        defaultMessage: "Info"
    }
});
const $8b1e24b6aff8f803$var$propertiesSectionStyles = (0, $ecnYn.xcss)({
    paddingLeft: 'space.300',
    paddingRight: 'space.300',
    marginTop: 'space.300'
});
const $8b1e24b6aff8f803$export$b04644a04c64ee0c = ({ highlightLabels: highlightLabels })=>{
    const [contentType] = (0, $ep3mz.useContentType)();
    const { isElementVisible: isElementVisible } = (0, $5qLRP.useElementVisibility)();
    const isClassificationRowVisible = (0, $818e9fd1178a0334$export$fa044869294621ea)();
    const rowsToRender = [];
    if (isElementVisible((0, $5qLRP.ELEMENTS).ROWS.STATUS)) rowsToRender.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $bJX6u.ContentStateStateContainer)
        ],
        key: (0, $5qLRP.ELEMENTS).ROWS.STATUS
    }, ({ state: state })=>{
        const { name: name = null, restrictionLevel: restrictionLevel, color: color = null } = state?.contentState ?? {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1645549588f034e2$export$8247e1fed55911f6), {
            name: name,
            restrictionLevel: restrictionLevel,
            color: color,
            isContentStateAvailable: !!state?.contentState
        });
    }));
    if (isClassificationRowVisible) rowsToRender.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ad489d36268c3761$export$b3b8c7ca0930ec22), {
        key: "classification"
    }));
    if (isElementVisible((0, $5qLRP.ELEMENTS).ROWS.REDACTIONS) && (0, $9wGTI.fg)('dlp_cc-redactions-metadata-modal')) rowsToRender.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9c39d074e22d6463$export$e1c60e781522ee95), {
        key: (0, $5qLRP.ELEMENTS).ROWS.REDACTIONS
    }));
    if (isElementVisible((0, $5qLRP.ELEMENTS).ROWS.LABELS)) rowsToRender.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a85fb67b97f12834$export$875bcf10b1b6719c), {
        key: (0, $5qLRP.ELEMENTS).ROWS.LABELS,
        highlight: highlightLabels
    }));
    let isInfoSectionTitleVisible = true;
    if (contentType === (0, $1ggpj.ContentType).WHITEBOARD && (0, $9wGTI.fg)('confluence_frontend_whiteboards_content_wrapper')) isInfoSectionTitleVisible = rowsToRender.length > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        xcss: $8b1e24b6aff8f803$var$propertiesSectionStyles
    }, isInfoSectionTitleVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...$8b1e24b6aff8f803$var$i18n.propertiesSectionTitle,
        tagName: "h4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).DISCO
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), null, rowsToRender)));
};

































var $h3IRN = parcelRequire("h3IRN");










/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 














const $add3920876d5aeb4$export$51d7c1016ebf3ff1 = (data)=>({
        incomingLinksCount: data?.singleContent?.incomingLinks?.count ?? 0,
        incomingLinksHasMore: data?.singleContent?.incomingLinks?.pageInfo?.hasNextPage ?? false,
        internalOutgoingLinksCount: data?.singleContent?.outgoingLinks?.internalOutgoingLinks?.count ?? 0,
        internalOutgoingLinksHasMore: data?.singleContent?.outgoingLinks?.internalOutgoingLinks?.pageInfo?.hasNextPage ?? false,
        externalOutgoingLinksCount: data?.singleContent?.outgoingLinks?.externalOutgoingLinks?.count ?? 0,
        externalOutgoingLinksHasMore: data?.singleContent?.outgoingLinks?.externalOutgoingLinks?.pageInfo?.hasNextPage ?? false
    });


const $63c497c9210162c7$var$useContentLinksDetailsPanelContentLinksQuery = (0, $eSUdr.default)`query useContentLinksDetailsPanelContentLinksQuery($contentId:ID!$status:String!$limit:Int!){singleContent(id:$contentId status:[$status]){id incomingLinks(first:$limit){count pageInfo{hasNextPage}}outgoingLinks{internalOutgoingLinks(first:$limit){count pageInfo{hasNextPage}}externalOutgoingLinks(first:$limit){count pageInfo{hasNextPage}}}}}`;
const $63c497c9210162c7$export$f8e4890e95352afe = (linkLimit)=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { contentStatus: contentStatus, loading: isContentStatusLoading, error: contentStatusError, refetch: refetchContentStatus } = (0, $htsj6.useContentStatus)();
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $j1Ss3.useQuery)($63c497c9210162c7$var$useContentLinksDetailsPanelContentLinksQuery, {
        variables: {
            contentId: contentId ?? '',
            status: contentStatus ?? '',
            limit: linkLimit
        },
        skip: isContentStatusLoading || !!contentStatusError || !contentStatus || !contentId
    });
    const normalizedData = (0, $42omo.useMemo)(()=>(0, $add3920876d5aeb4$export$51d7c1016ebf3ff1)(data), [
        data
    ]);
    return {
        data: normalizedData,
        loading: loading,
        error: contentStatusError || error,
        refetch: !!contentStatusError ? refetchContentStatus : refetch
    };
};





const $d3938577f77dcc89$var$i18n = (0, $cgtv4.defineMessages)({
    incomingLinks: {
        id: "details-panel.links-section.incoming-links-row",
        defaultMessage: "Incoming links"
    }
});
const $d3938577f77dcc89$var$linkLimit = 50;
const $d3938577f77dcc89$export$73809ff06e5069c3 = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { data: data, error: error, refetch: refetch, loading: loading } = (0, $63c497c9210162c7$export$f8e4890e95352afe)($d3938577f77dcc89$var$linkLimit);
    const { incomingLinksCount: incomingLinksCount, incomingLinksHasMore: incomingLinksHasMore } = data;
    if (!incomingLinksCount && !error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "incoming-links-empty-row"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
        name: "incoming-links-details-panel-hold",
        hold: loading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7489de58f9d21175$export$3ea9d70abca6f185), {
        itemName: formatMessage($d3938577f77dcc89$var$i18n.incomingLinks),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h3IRN))), {
            label: ""
        })
    }, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c5268d744aecc17b$export$51c55327f05e286f), {
        error: error,
        refetch: refetch
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a99dcf3b2d873545$export$902dde2c01bb0707), {
        href: `${(0, $jlIaF.CONTEXT_PATH)}/pages/viewinfo.action?pageId=${contentId}`,
        analyticsContext: {
            source: 'contentWrapper',
            attributes: {
                name: 'incomingLinks',
                count: incomingLinksCount,
                hasMore: incomingLinksHasMore
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "incoming-links-count"
    }, incomingLinksCount, incomingLinksHasMore ? '+' : ''))));
};











var $69PnT = parcelRequire("69PnT");














const $54c4b47034898c7f$var$i18n = (0, $cgtv4.defineMessages)({
    outgoingLinks: {
        id: "details-panel.links-section.outgoing-links-row",
        defaultMessage: "Outgoing links"
    }
});
const $54c4b47034898c7f$var$linkLimit = 50;
const $54c4b47034898c7f$export$745e6d0a4023e79a = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { data: data, error: error, refetch: refetch, loading: loading } = (0, $63c497c9210162c7$export$f8e4890e95352afe)($54c4b47034898c7f$var$linkLimit);
    const { internalOutgoingLinksCount: internalOutgoingLinksCount, internalOutgoingLinksHasMore: internalOutgoingLinksHasMore, externalOutgoingLinksCount: externalOutgoingLinksCount, externalOutgoingLinksHasMore: externalOutgoingLinksHasMore } = data;
    let outgoingLinksCount = internalOutgoingLinksCount + externalOutgoingLinksCount;
    let hasMoreOutgoingLinks = internalOutgoingLinksHasMore || externalOutgoingLinksHasMore;
    if (outgoingLinksCount > $54c4b47034898c7f$var$linkLimit) {
        outgoingLinksCount = $54c4b47034898c7f$var$linkLimit;
        hasMoreOutgoingLinks = true;
    }
    if (!outgoingLinksCount && !error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "outgoing-links-empty-row"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
        name: "ougoing-links-details-panel-hold",
        hold: loading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7489de58f9d21175$export$3ea9d70abca6f185), {
        itemName: formatMessage($54c4b47034898c7f$var$i18n.outgoingLinks),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($69PnT))), {
            label: ""
        })
    }, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c5268d744aecc17b$export$51c55327f05e286f), {
        error: error,
        refetch: refetch
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a99dcf3b2d873545$export$902dde2c01bb0707), {
        href: `${(0, $jlIaF.CONTEXT_PATH)}/pages/viewinfo.action?pageId=${contentId}`,
        analyticsContext: {
            source: 'contentWrapper',
            attributes: {
                name: 'outgoingLinks',
                count: outgoingLinksCount,
                hasMore: hasMoreOutgoingLinks
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "outgoing-links-count"
    }, outgoingLinksCount, hasMoreOutgoingLinks ? '+' : ''))));
};











var $7ZcJJ = parcelRequire("7ZcJJ");





var $3jwuS = parcelRequire("3jwuS");


var $de2j9 = parcelRequire("de2j9");























var $hpUsb = parcelRequire("hpUsb");


var $bYRk6 = parcelRequire("bYRk6");


var $7hXDW = parcelRequire("7hXDW");





var $aoVih = parcelRequire("aoVih");

var $iHPbg = parcelRequire("iHPbg");





var $6M71K = parcelRequire("6M71K");

const $379586560174b3c0$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    viewMoreInJiraLinkText: {
        id: "details-panel.links-section.jira-work-items-panel-body.view-more-link-text",
        defaultMessage: "View {count} more in System Jira"
    },
    viewMoreInJiraLinkTextByGroup: {
        id: "details-panel.links-section.jira-work-items-panel-body.view-more-link-text-by-group",
        defaultMessage: "View {groupType} in Jira"
    },
    workItemsCount: {
        id: "details-panel.links-section.jira-work-items-panel-body.work-items-count",
        defaultMessage: "{count, plural, one {# work item} other {# work items}}"
    },
    authenticationNeeded: {
        id: "details-panel.links-section.jira-work-items-panel-body.authentication-needed",
        defaultMessage: "Authentication Needed"
    },
    loginToRetrieveData: {
        id: "details-panel.links-section.jira-work-items-panel-body.login-to-retrieve-data",
        defaultMessage: "Login to retrieve data from:"
    },
    reloadPage: {
        id: "details-panel.links-section.jira-work-items-panel-body.reload-page",
        defaultMessage: "Please reload the page to try again"
    }
});
const $379586560174b3c0$var$panelBodyStyles = (0, $ecnYn.xcss)({
    paddingInline: 'space.400'
});
const $379586560174b3c0$export$b5fd1500b92a9599 = (jiraMetadata)=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const jiraIssuesMetadata = jiraMetadata.groups.find((group)=>group.type === 'ISSUES');
    const jiraAppLinksMetadata = jiraMetadata.unauthorisedAppLinks;
    const workItemsJQLSearchUrlMap = (0, $42omo.useMemo)(()=>jiraMetadata.groups.reduce((map, group)=>{
            const jiraLink = group.links.find((link)=>link.appName === 'System Jira');
            if (jiraLink) map[group.type] = jiraLink.url;
            return map;
        }, {}), [
        jiraMetadata.groups
    ]);
    const issuesJQLSearchUrl = jiraIssuesMetadata?.links.find((link)=>link.appName === 'System Jira')?.url;
    const totalJiraLinksCount = jiraMetadata.count;
    //include all work items from all groups behind fg
    const workItems = (0, $9wGTI.fg)('confluence-jira-all-work-items') ? jiraMetadata.groups.flatMap((group)=>group.items) : jiraIssuesMetadata?.items;
    const openInNewTab = (issueUrl)=>{
        window.open(issueUrl, '_blank', 'noopener,noreferrer');
    };
    if (!workItems || !totalJiraLinksCount) return null;
    const context = {
        source: 'linkedJiraWorkItems'
    };
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        xcss: $379586560174b3c0$var$panelBodyStyles,
        alignBlock: "start",
        space: "space.200",
        testId: "jira-work-items-panel-body"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        testId: "jira-work-items-panel-heading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7hXDW.default), {
        size: "small"
    }, formatMessage($379586560174b3c0$export$a7357cdd1f0b0168.workItemsCount, {
        count: totalJiraLinksCount
    }))), workItems.map((issue, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            testId: "smartlink-item-wrapper",
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bYRk6.default), {
            data: context
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hpUsb.Card), {
            url: issue.url,
            appearance: "inline",
            onClick: ()=>openInNewTab(issue.url)
        })))), Object.keys(workItemsJQLSearchUrlMap).length > 0 && (0, $9wGTI.fg)('confluence-jira-all-work-items') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        testId: "jira-work-items-panel-jql-links"
    }, formatMessage($379586560174b3c0$export$a7357cdd1f0b0168.viewMoreInJiraLinkText, {
        count: jiraMetadata.count - workItems.length
    }), ":", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        as: "ul"
    }, Object.entries(workItemsJQLSearchUrlMap).map(([groupType, url], index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            as: "li",
            key: groupType,
            testId: `jira-work-items-panel-jql-link-${index}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
            target: "_blank",
            href: url
        }, formatMessage($379586560174b3c0$export$a7357cdd1f0b0168.viewMoreInJiraLinkTextByGroup, {
            groupType: groupType.toLowerCase()
        })))))) : issuesJQLSearchUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        testId: "jira-work-items-panel-jql-link"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        target: "_blank",
        href: issuesJQLSearchUrl
    }, formatMessage($379586560174b3c0$export$a7357cdd1f0b0168.viewMoreInJiraLinkText, {
        count: jiraMetadata.count - workItems.length
    }))), jiraAppLinksMetadata.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
        title: formatMessage($379586560174b3c0$export$a7357cdd1f0b0168.authenticationNeeded),
        appearance: "warning",
        actions: [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
                as: "ul",
                key: "auth-links"
            }, jiraAppLinksMetadata.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                    as: "li",
                    key: item.htmlSafeName
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iHPbg.default), null, item.authorisationUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                    href: item.authorisationUrl,
                    target: "_blank",
                    rel: "noopener,noreferrer"
                }, item.name) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, item.name, " - ", formatMessage($379586560174b3c0$export$a7357cdd1f0b0168.reloadPage))))))
        ]
    }, formatMessage($379586560174b3c0$export$a7357cdd1f0b0168.loginToRetrieveData)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6M71K.ConfluenceSmartCardProvider), null, content));
};













const $64fc2a01f5307e91$var$i18n = (0, $cgtv4.defineMessages)({
    jiraWorkItemsPanelHeaderIcon: {
        id: "details-panel.jira-work-items.header.icon.label",
        defaultMessage: "Jira work items Icon"
    }
});
const $64fc2a01f5307e91$export$4f6ac55ab232a72a = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7ZcJJ))), {
        label: formatMessage($64fc2a01f5307e91$var$i18n.jiraWorkItemsPanelHeaderIcon)
    });
};











var $bPdpL = parcelRequire("bPdpL");












const $338642815de47c2a$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    detailsPanelHeaderLabel: {
        id: "details-panel.panel.header.label",
        defaultMessage: "Details"
    },
    iconButtonLabel: {
        id: "details-panel.jira-work-items-panel.header-navigation.icon-button",
        defaultMessage: "return-to-content-details"
    },
    leftArrowIconLabel: {
        id: "details-panel.jira-work-items-panel.header-navigation.left-arrow-icon",
        defaultMessage: "back-icon"
    }
});
const $338642815de47c2a$export$4b70900bd141d903 = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { showObjectSidebar: showObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const showDetailsPanel = ()=>{
        showObjectSidebar({
            id: (0, $jvYFk.PanelName).DetailsPanel,
            headerComponentElements: {
                HeaderIcon: (0, $c3510951803c5233$export$b127d30889efe7fe),
                headerLabel: $338642815de47c2a$export$a7357cdd1f0b0168.detailsPanelHeaderLabel
            },
            BodyComponent: (0, $27b90458aead410f$export$7b946ff6a74a6839)
        }, 'push');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bPdpL))), {
                label: formatMessage($338642815de47c2a$export$a7357cdd1f0b0168.leftArrowIconLabel),
                spacing: "none"
            }),
        appearance: "subtle",
        label: formatMessage($338642815de47c2a$export$a7357cdd1f0b0168.iconButtonLabel),
        onClick: showDetailsPanel,
        testId: "naviagte-back-to-details-panel-button"
    });
};


const $6413d1effe174ea4$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    jiraWorkItemsPanelHeaderLabel: {
        id: "details-panel.jira-work-items.header.label",
        defaultMessage: "Jira work items"
    }
});
const $6413d1effe174ea4$export$11974192ac11a6be = (jiraMetaData)=>{
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const panel = (0, $aWwYt.usePanel)();
    const { showObjectSidebar: showObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const panelId = 'jiraWorkItemsPanel';
    const showJiraWorkItemsPanel = ()=>{
        showObjectSidebar({
            id: panelId,
            headerComponentElements: {
                HeaderIcon: (0, $64fc2a01f5307e91$export$4f6ac55ab232a72a),
                headerLabel: $6413d1effe174ea4$export$a7357cdd1f0b0168.jiraWorkItemsPanelHeaderLabel,
                HeaderBeforeIconElement: (0, $338642815de47c2a$export$4b70900bd141d903)
            },
            BodyComponent: ()=>(0, $379586560174b3c0$export$b5fd1500b92a9599)(jiraMetaData)
        }, 'push');
    };
    return {
        isJiraWorkItemsPanelShown: isObjectSidebarShown && panel?.id === panelId,
        showJiraWorkItemsPanel: showJiraWorkItemsPanel
    };
};












var $f7B1p = parcelRequire("f7B1p");

const $e40838b1edee5144$var$getJiraMetadataEndpoint = (contentId)=>{
    return `/wiki/rest/jira-metadata/1.0/metadata?pageId=${contentId}`;
};
const $e40838b1edee5144$export$e5f56020a6ff0318 = async (contentId)=>{
    const response = await (0, $f7B1p.cfetch)($e40838b1edee5144$var$getJiraMetadataEndpoint(contentId), {
        method: 'GET',
        headers: {
            Accept: 'application/json'
        },
        credentials: 'include'
    });
    return response.json();
};


const $e947a3a1489ee888$export$1bd5cee589f02d6d = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [data, setData] = (0, $42omo.useState)(null);
    const [fetchError, setFetchError] = (0, $42omo.useState)(null);
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false);
    const fireSuccessAnalytics = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'success',
                actionSubject: 'fetchJiraMetadata',
                source: 'linkedJiraWorkItems'
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const fireFailureAnalytics = (0, $42omo.useCallback)((error)=>{
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'failure',
                actionSubject: 'fetchJiraMetadata',
                source: 'linkedJiraWorkItems',
                attributes: {
                    error: error
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const getJiraMetadata = (0, $42omo.useCallback)(async ()=>{
        if (!contentId) return;
        setIsLoading(true);
        try {
            const jiraMetaData = await (0, $e40838b1edee5144$export$e5f56020a6ff0318)(contentId);
            if (!jiraMetaData) throw new Error('No Jira metadata has been fetched');
            fireSuccessAnalytics();
            setData(jiraMetaData);
        } catch (error) {
            fireFailureAnalytics(error);
            setFetchError(error instanceof Error ? error : new Error('Request to getJiraMetadata failed'));
        } finally{
            setIsLoading(false);
        }
    }, [
        contentId,
        fireSuccessAnalytics,
        fireFailureAnalytics
    ]);
    (0, $42omo.useEffect)(()=>{
        getJiraMetadata();
    }, [
        getJiraMetadata
    ]);
    return {
        data: data,
        error: fetchError,
        isLoading: isLoading,
        refetch: getJiraMetadata
    };
};





const $99e0d826fd8e4a43$var$i18n = (0, $cgtv4.defineMessages)({
    jiraWorkItems: {
        id: "details-panel.links-section.jira-work-items-row",
        defaultMessage: "Jira work items"
    },
    jiraWorkItem: {
        id: "details-panel.links-section.jira-work-item-row",
        defaultMessage: "Jira work item"
    }
});
const $99e0d826fd8e4a43$export$ffa1ac485496a25b = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { data: data, isLoading: isLoading, error: error, refetch: refetch } = (0, $e947a3a1489ee888$export$1bd5cee589f02d6d)();
    const { showJiraWorkItemsPanel: showJiraWorkItemsPanel } = (0, $6413d1effe174ea4$export$11974192ac11a6be)(data);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const shouldRenderDetailRow = (0, $42omo.useMemo)(()=>!isLivePage && !isOnEditRoute && !isLoading && (data && data.count > 0 || error), [
        isLivePage,
        isOnEditRoute,
        isLoading,
        data,
        error
    ]);
    (0, $42omo.useEffect)(()=>{
        if (shouldRenderDetailRow && !error) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'shown',
                actionSubject: 'jiraWorkItemsRow',
                source: 'linkedJiraWorkItems',
                attributes: {
                    count: data?.count
                }
            }
        }).fire();
    }, [
        shouldRenderDetailRow,
        error,
        createAnalyticsEvent,
        data
    ]);
    return shouldRenderDetailRow ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7489de58f9d21175$export$3ea9d70abca6f185), {
        itemName: formatMessage(data && data.count > 1 ? $99e0d826fd8e4a43$var$i18n.jiraWorkItems : $99e0d826fd8e4a43$var$i18n.jiraWorkItem),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7ZcJJ))), {
            label: ""
        })
    }, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c5268d744aecc17b$export$51c55327f05e286f), {
        error: error,
        refetch: refetch
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a99dcf3b2d873545$export$902dde2c01bb0707), {
        onClick: showJiraWorkItemsPanel,
        analyticsContext: {
            source: 'contentWrapper',
            attributes: {
                name: 'jiraWorkItems',
                count: data?.count
            }
        }
    }, data?.count)) : null;
};











var $jdPfT = parcelRequire("jdPfT");






















const $f15f4d9d482cc07b$export$2b23b879dbd3c7c4 = async (contentId, contentType)=>{
    try {
        // v2 APIs pluralise all the content types... and if we don't get a type, default to pages
        const contentTypeForApi = contentType ? `${contentType}s` : 'pages';
        const response = await (0, $f7B1p.cfetch)(`/wiki/api/v2/${contentTypeForApi}/${contentId}/custom-content`);
        return response.json();
    } catch (error) {
        return {
            errors: [
                {
                    status: 500,
                    code: 'unknown',
                    title: 'Error',
                    detail: error.message
                }
            ]
        };
    }
};


const $dd3706d0c3f7c313$export$1a2b9ee3778620e7 = ()=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { type: contentType } = (0, $htsj6.useContentStatus)();
    const [customContentCount, setCustomContentCount] = (0, $42omo.useState)(0);
    const [customContentError, setCustomContentError] = (0, $42omo.useState)(undefined);
    const [loading, setLoading] = (0, $42omo.useState)(false);
    const fetchCustomContent = (0, $42omo.useCallback)(async ()=>{
        if (!contentId) return;
        setCustomContentError(undefined);
        setCustomContentCount(0);
        if (navigator.onLine) {
            setLoading(true);
            try {
                const response = await (0, $f15f4d9d482cc07b$export$2b23b879dbd3c7c4)(contentId, contentType);
                if ('errors' in response) setCustomContentError(new Error(response.errors.map(({ code: code, detail: detail, status: status, title: title })=>`${status} - ${code} - ${title} - ${detail}`).join(',')));
                else setCustomContentCount(response.results.length);
            } catch (error) {
                setCustomContentError(new Error(`500 - unknown - Error - ${error.message}`));
            } finally{
                setLoading(false);
            }
        }
    }, [
        contentId,
        contentType
    ]);
    (0, $42omo.useEffect)(()=>{
        fetchCustomContent();
    }, [
        fetchCustomContent
    ]);
    return {
        data: {
            customContentCount: customContentCount
        },
        error: customContentError,
        loading: loading,
        refetch: fetchCustomContent
    };
};





const $1ca3a459c0e0ae69$var$i18n = (0, $cgtv4.defineMessages)({
    customContent: {
        id: "details-panel.links-section.custom-content-row",
        defaultMessage: "Custom content"
    }
});
const $1ca3a459c0e0ae69$export$472cb29981ee8ce0 = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { data: data, error: error, refetch: refetch, loading: loading } = (0, $dd3706d0c3f7c313$export$1a2b9ee3778620e7)();
    const { customContentCount: customContentCount } = data;
    if (!customContentCount && !error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "custom-content-empty-row"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
        name: "custom-content-row-details-panel-hold",
        hold: loading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7489de58f9d21175$export$3ea9d70abca6f185), {
        itemName: formatMessage($1ca3a459c0e0ae69$var$i18n.customContent),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
            label: ""
        })
    }, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c5268d744aecc17b$export$51c55327f05e286f), {
        error: error,
        refetch: refetch
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a99dcf3b2d873545$export$902dde2c01bb0707), {
        href: (0, $1NBp8.CUSTOM_CONTENTS_ON_PAGE_LIST).toUrl({
            contentId: contentId,
            spaceKey: spaceKey
        }),
        analyticsContext: {
            source: 'contentWrapper',
            attributes: {
                name: 'customContent',
                count: customContentCount
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "custom-content-count"
    }, customContentCount))));
};














var $9lz2c = parcelRequire("9lz2c");













/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 














const $35280d2dcde04e20$export$7005b14840b4a0d4 = (data)=>({
        attachmentsCount: data?.singleContent?.attachments?.count ?? 0,
        hasMoreAttachments: data?.singleContent?.attachments?.pageInfo?.hasNextPage ?? false
    });


const $7131f83e62ec8e0d$var$useContentAttachmentsDetailsPanelContentAttachmentsQuery = (0, $eSUdr.default)`query useContentAttachmentsDetailsPanelContentAttachmentsQuery($contentId:ID!$status:String!$limit:Int!){singleContent(id:$contentId status:[$status]){id attachments(first:$limit){count pageInfo{hasNextPage}}}}`;
const $7131f83e62ec8e0d$export$54932d90334e20cc = (attachmentsLimit)=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { contentStatus: contentStatus, loading: isContentStatusLoading, error: contentStatusError, refetch: refetchContentStatus } = (0, $htsj6.useContentStatus)();
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $j1Ss3.useQuery)($7131f83e62ec8e0d$var$useContentAttachmentsDetailsPanelContentAttachmentsQuery, {
        variables: {
            contentId: contentId ?? '',
            status: contentStatus ?? '',
            limit: attachmentsLimit
        },
        skip: isContentStatusLoading || !!contentStatusError || !contentStatus || !contentId
    });
    const normalizedData = (0, $42omo.useMemo)(()=>(0, $35280d2dcde04e20$export$7005b14840b4a0d4)(data), [
        data
    ]);
    return {
        data: normalizedData,
        loading: loading,
        error: contentStatusError || error,
        refetch: !!contentStatusError ? refetchContentStatus : refetch
    };
};





const $d0d56f722905f522$var$i18n = (0, $cgtv4.defineMessages)({
    attachments: {
        id: "details-panel.links-section.attachments",
        defaultMessage: "Attachments"
    }
});
const $d0d56f722905f522$var$attachmentsLimit = 50;
const $d0d56f722905f522$export$1e2a67404ea6f893 = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $7131f83e62ec8e0d$export$54932d90334e20cc)($d0d56f722905f522$var$attachmentsLimit);
    const { attachmentsCount: attachmentsCount, hasMoreAttachments: hasMoreAttachments } = data;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onClick = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: `button`,
                actionSubjectId: 'SidePanelFiles',
                source: 'contentWrapper'
            }
        }).fire();
    };
    const renderFilesContent = ()=>{
        if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
            name: "attachments-row-details-panel-hold"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "48px",
            height: "24px",
            borderRadius: 3,
            testId: "attachments-row-loading"
        }));
        if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c5268d744aecc17b$export$51c55327f05e286f), {
            error: error,
            refetch: refetch
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a99dcf3b2d873545$export$902dde2c01bb0707), {
            href: `${(0, $jlIaF.CONTEXT_PATH)}/pages/viewpageattachments.action?pageId=${contentId}`,
            onClick: onClick
        }, attachmentsCount, hasMoreAttachments ? '+' : '');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7489de58f9d21175$export$3ea9d70abca6f185), {
        itemName: formatMessage($d0d56f722905f522$var$i18n.attachments),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9lz2c))), {
            label: ""
        })
    }, renderFilesContent());
};


const $78f5f8494339f666$var$i18n = (0, $cgtv4.defineMessages)({
    connectionsSectionTitle: {
        id: "details-panel.connections-section.title",
        defaultMessage: "Connections"
    }
});
const $78f5f8494339f666$var$connectionsSectionStyles = (0, $ecnYn.xcss)({
    paddingLeft: 'space.300',
    paddingRight: 'space.300',
    marginTop: 'space.300'
});
const $78f5f8494339f666$export$62aa1e9cfa771dff = ()=>{
    const { isElementVisible: isElementVisible } = (0, $5qLRP.useElementVisibility)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        testId: "connections-section",
        xcss: $78f5f8494339f666$var$connectionsSectionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...$78f5f8494339f666$var$i18n.connectionsSectionTitle,
        tagName: "h4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).DISCO
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d3938577f77dcc89$export$73809ff06e5069c3), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $54c4b47034898c7f$export$745e6d0a4023e79a), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d0d56f722905f522$export$1e2a67404ea6f893), null), isElementVisible((0, $5qLRP.ELEMENTS).ROWS.CUSTOM_CONTENT) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1ca3a459c0e0ae69$export$472cb29981ee8ce0), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $99e0d826fd8e4a43$export$ffa1ac485496a25b), null))));
};





const $27b90458aead410f$var$DetailsPanelComponent = ({ highlightLabels: highlightLabels })=>{
    const { isElementVisible: isElementVisible } = (0, $5qLRP.useElementVisibility)();
    const [contentType] = (0, $ep3mz.useContentType)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        testId: "details-panel-body"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a458f954e7688173$export$dd2d4d0b8ec52ff3), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d646f513af901061$export$49e22b3583223277), null), isElementVisible((0, $5qLRP.ELEMENTS).SECTIONS.PROPERTIES) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8b1e24b6aff8f803$export$b04644a04c64ee0c), {
        highlightLabels: highlightLabels
    }), isElementVisible((0, $5qLRP.ELEMENTS).SECTIONS.CONNECTIONS) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $78f5f8494339f666$export$62aa1e9cfa771dff), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.SIDEBAR_DETAILS_PANEL_LOAD_EXPERIENCE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $67Foi.ScreenEvent), {
        name: "detailsPanelScreen",
        id: "detailsPanelScreen",
        attributes: {
            contentType: contentType,
            isOpenedFromFooterLabels: highlightLabels
        }
    }));
};
const $27b90458aead410f$export$7b946ff6a74a6839 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).DISCO
})($27b90458aead410f$var$DetailsPanelComponent);


const $4119a6166d969e95$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    detailsPanelHeaderLabel: {
        id: "details-panel.panel.header.label",
        defaultMessage: "Details"
    }
});
const $4119a6166d969e95$export$fd546c83bdd1393d = ()=>{
    const { showObjectSidebar: showObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const panel = (0, $aWwYt.usePanel)();
    const showDetailsPanel = ({ highlightLabels: highlightLabels } = {})=>{
        showObjectSidebar({
            id: (0, $jvYFk.PanelName).DetailsPanel,
            headerComponentElements: {
                HeaderIcon: (0, $c3510951803c5233$export$b127d30889efe7fe),
                headerLabel: $4119a6166d969e95$export$a7357cdd1f0b0168.detailsPanelHeaderLabel
            },
            BodyComponent: (0, $27b90458aead410f$export$7b946ff6a74a6839),
            props: {
                highlightLabels: highlightLabels
            }
        }, 'push');
    };
    return {
        isDetailsPanelShown: isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).DetailsPanel,
        showDetailsPanel: showDetailsPanel
    };
};
module.exports["useShowDetailsPanel"] = $4119a6166d969e95$export$fd546c83bdd1393d;

});

parcelRegister("5qLRP", function(module, exports) {

var $gEtAQ = parcelRequire("gEtAQ");


var $ep3mz = parcelRequire("ep3mz");


var $bMPhU = parcelRequire("bMPhU");


var $1ggpj = parcelRequire("1ggpj");


var $9wGTI = parcelRequire("9wGTI");

const $db5b264ea04b1a6b$export$a6d18b072e3b7ccb = {
    ROWS: {
        CUSTOM_CONTENT: 'customContent',
        VIEWS: 'views',
        LENGTH: 'length',
        STATUS: 'status',
        REDACTIONS: 'redactions',
        LABELS: 'labels'
    },
    SECTIONS: {
        PROPERTIES: 'properties',
        CONNECTIONS: 'connections'
    }
};
const $db5b264ea04b1a6b$export$e09a3109414746fb = {
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.ROWS.CUSTOM_CONTENT]: false,
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.ROWS.STATUS]: false,
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.ROWS.REDACTIONS]: false
};
const $db5b264ea04b1a6b$export$28f9a36e98aa9cf4 = {
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.ROWS.VIEWS]: false,
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.ROWS.LENGTH]: false,
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.ROWS.STATUS]: false,
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.ROWS.REDACTIONS]: false,
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.ROWS.LABELS]: false,
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.SECTIONS.CONNECTIONS]: false
};
const $db5b264ea04b1a6b$export$e96bb3f3767bc352 = {
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.ROWS.VIEWS]: false,
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.ROWS.LENGTH]: false,
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.ROWS.STATUS]: false,
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.ROWS.REDACTIONS]: false,
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.ROWS.LABELS]: false,
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.SECTIONS.CONNECTIONS]: false
};
const $db5b264ea04b1a6b$export$6aadc312a449609d = ()=>{
    const isSpaceOverviewViewMode = (0, $gEtAQ.isSpaceOverview)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const homepageId = (0, $bMPhU.useSpaceHomepageId)(spaceKey);
    const isSpaceOverviewEditMode = homepageId === contentId;
    const isSpaceOverviewPage = isSpaceOverviewViewMode || isSpaceOverviewEditMode;
    const getVisibilityConfig = ()=>{
        if (isSpaceOverviewPage) return $db5b264ea04b1a6b$export$e09a3109414746fb;
        if (contentType === (0, $1ggpj.ContentType).DATABASE) return $db5b264ea04b1a6b$export$28f9a36e98aa9cf4;
        if (contentType === (0, $1ggpj.ContentType).WHITEBOARD) return $db5b264ea04b1a6b$export$e96bb3f3767bc352;
        return null;
    };
    const isElementVisible = (element)=>{
        if (element === $db5b264ea04b1a6b$export$a6d18b072e3b7ccb.ROWS.LABELS && (contentType === (0, $1ggpj.ContentType).DATABASE || contentType === (0, $1ggpj.ContentType).WHITEBOARD)) return (0, $9wGTI.fg)('confluence_frontend_labels_wb_db');
        const visibilityConfig = getVisibilityConfig();
        return (visibilityConfig && visibilityConfig[element]) ?? true;
    };
    return {
        isElementVisible: isElementVisible
    };
};
module.exports["ELEMENTS"] = $db5b264ea04b1a6b$export$a6d18b072e3b7ccb;
module.exports["useElementVisibility"] = $db5b264ea04b1a6b$export$6aadc312a449609d;

});

parcelRegister("3l7KO", function(module, exports) {
/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $ep3mz = parcelRequire("ep3mz");

const $02e404c086402fb8$export$1dee72c052fd59a0 = (data)=>{
    const nodes = data?.singleContent?.labels?.nodes;
    const firstNode = data?.content?.nodes?.[0];
    const operations = firstNode?.operations ?? [];
    const type = firstNode?.type;
    const hasEditPermissions = Boolean(operations?.find((item)=>item?.operation === 'update' && item?.targetType === type));
    const labels = nodes?.filter((node)=>node?.name !== 'favourite' || node?.prefix !== 'my') || [];
    return {
        labels: labels,
        hasEditPermissions: hasEditPermissions
    };
};


const $b684b72ae3cf6eec$var$useContentLabelsDetailsPanelContentLabelsQuery = (0, $eSUdr.default)`query useContentLabelsDetailsPanelContentLabelsQuery($contentId:ID!){singleContent(id:$contentId){id labels(orderBy:{sortField:LABELLING_CREATIONDATE direction:ASCENDING}){count nodes{id label name prefix}}}content(id:$contentId status:["archived" "current" "draft"]){nodes{id type operations{operation targetType}}}}`;
const $b684b72ae3cf6eec$var$useContentLabelsDetailsPanelContentLabelDeleteMutation = (0, $eSUdr.default)`mutation useContentLabelsDetailsPanelContentLabelDeleteMutation($contentId:ID!$label:String!){deleteLabel(input:{contentId:$contentId label:$label}){contentId}}`;
const $b684b72ae3cf6eec$export$6a1788a7b791cea2 = ()=>{
    const [contentId = ''] = (0, $ep3mz.usePageContentId)();
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $j1Ss3.useQuery)($b684b72ae3cf6eec$var$useContentLabelsDetailsPanelContentLabelsQuery, {
        variables: {
            contentId: contentId
        },
        skip: !contentId
    });
    const [handleDeleteLabelClick] = (0, $j1Ss3.useMutation)($b684b72ae3cf6eec$var$useContentLabelsDetailsPanelContentLabelDeleteMutation);
    const normalizedData = (0, $42omo.useMemo)(()=>(0, $02e404c086402fb8$export$1dee72c052fd59a0)(data), [
        data
    ]);
    return {
        data: normalizedData,
        handleDeleteLabelClick: handleDeleteLabelClick,
        loading: loading,
        error: error,
        refetch: refetch
    };
};
module.exports["useContentLabels"] = $b684b72ae3cf6eec$export$6a1788a7b791cea2;

});

parcelRegister("dqRJo", function(module, exports) {

let $9c7761efabbe487c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9c7761efabbe487c$var$load("49GA1"),
    $9c7761efabbe487c$var$load("32K9i"),
    $9c7761efabbe487c$var$load("6wr18"),
    $9c7761efabbe487c$var$load("ffEVr"),
    $9c7761efabbe487c$var$load("1FzbR")
]).then(()=>parcelRequire('iWY6a'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("byF4U", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $a8249b7ea6acc225$export$41d44f18573bbe1d = (0, $eSUdr.default)`query DetailsPanelRedactionsRowQuery($contentId:ID!){singleContent(id:$contentId){id redactionMetadataCount}}`;
module.exports["DetailsPanelRedactionsRowQuery"] = $a8249b7ea6acc225$export$41d44f18573bbe1d;

});


//# sourceMappingURL=labels-footer.98af97be.js.map
